export default {
  "account-candidate-content": "スキル評価を受けて、\n技術力を証明しましょう。",
  "account-organization-title": "組織",
  "account-organization-content": "受験者の技術力を評価し、\nデータに基づいた意思決定を行いましょう。",
  "sign-up-top-title": "コードプレッソのアカウントを作成",
  "account-login": "ログイン",
  "account-signup": "会員登録",
  "account-email": "メールアドレス",
  "account-password": "パスワード",
  "social-title": "または",
  "social-linkedin": "LinkedIn",
  "social-google": "Google",
  "sign-up-term-content": "コードプレッソの{policy}及び{term}に同意し、本人が16歳以上であることを確認します。",
  "common-terms-of-use": "利用規約",
  "common-legal-notice": "法的通知",
  "common-privacy-policy": "プライバシーポリシー",
  "common-cookie-policy": "クッキーポリシー",
  "sign-up-bottom": "すでにアカウントをお持ちですか？",
  "error-null-email": "メールアドレスを入力してください。",
  "error-personal-email": "個人メールアドレスや一時的なメールアドレスはご利用いただけません。\n業務用メールアドレスを入力してください。",
  "error-signup-blocked": "入力されたメールアドレスでは会員登録できません。\nもう一度お試しのうえ、問題が解決しない場合は、support@codepresso.io までお問い合わせください。",
  "error-null-password": "パスワードは10文字以上で入力してください。",
  "error-sign-wrong-approach": "エラーが発生し、リクエストされた操作ができません。\nもう一度お試しください。",
  "error-invalid-email": "メールアドレスが正しいかご確認ください。",
  "error-invalid-password-size": "パスワードは10文字以上で設定してください。",
  "error-invalid-password": "パスワードは数字と英字で大文字と小文字を含む必要があります。",
  "sign-send-verification-email": "認証メールが送信されました。",
  "sign-verify-email-title": "コードプレッソを利用するには、\nメール認証を行ってください",
  "sign-verify-email-content": "'{email}'送信されたメールを確認し、認証を行ってください。 認証メールが届いてない場合は、下のボタンをクリックして再送信することができます。",
  "sign-verify-email-resend": "認証メールの再送信",
  "sign-resend-verification-email": "認証メールが再送信されました。",
  "sign-send-verification-email-delay": "現在は再送信することができません。お手数をおかけしますが、30秒後に再度お試しください。",
  "sign-up-complete-title": "すべての準備が完了しました",
  "sign-up-complete-content": "'{email}'アカウントのメール認証が完了したので、これからコードプレッソをご利用いただけます。",
  "common-start": "利用する",
  "sign-up-fail-title": "認証メールを再送してください",
  "sign-up-fail-description": "認証リンクの有効期限が切れているため、メール認証ができません。",
  "sign-up-error-title": "技術的なエラーでメールを確認できません",
  "sign-up-error-content": "メール本文のボタンをクリックして再度お試しください。",
  "sign-in-top-title": "アカウントにログイン",
  "sign-in-bottom": "アカウントをお持ちではありませんか？",
  "account-find-password": "パスワードを忘れました。",
  "error-account-mis-match": "メールアドレスとパスワードが正しいか確認してください。",
  "error-used-email": "既に登録されているメールアドレスです。",
  "account-required": "ログインが必要です。",
  "account-up-required": "会員登録が必要です。",
  "password-change-enter-email": "メールアドレスを入力してください",
  "password-change-send-mail-content": "パスワードリセットのためのメールが送信されます。",
  "password-change-send-mail": "メール送信",
  "password-change-send-success-dot": "パスワードリセットのメールが送信されました。",
  "password-change-send-success": "パスワードリセットのメールが送信されました",
  "password-change-resend-mail-content-1": "'{email}'メールに送信されたメールを確認し、パスワードリセットを行ってください。",
  "password-change-resend-mail-content-2": "パスワード再設定メールが届かない場合は、下のボタンをクリックして再送信することができます。",
  "password-change-resend-email": "パスワードリセットメールを再送信",
  "password-change-resend-success": "パスワードリセットメールが再送信されました。",
  "password-change-resend-delay": "30秒後にパスワードリセットメールを再送信することができます。",
  "password-change-title": "新しいパスワードを設定してください",
  "password-change-content": "'{email}'アカウントの新しいパスワードを以下に入力してください。",
  "password-change-new-password": "新しいパスワード",
  "password-change-confirm-new-password": "新しいパスワードの確認",
  "password-change": "パスワード変更",
  "error-null-new-password": "新しいパスワードを入力する必要があります。",
  "error-null-confirm-new-password": "新しいパスワードと新しいパスワード確認が一致していることを確認してください。",
  "error-save-new-password": "エラーが発生したため、新しいパスワードを保存できません。",
  "password-change-success": "パスワードの変更が完了しました",
  "password-change-continue": "'{email}'アカウントのパスワードが変更されました。\n続行するには、アカウントにログインしてください。",
  "password-change-login-account": "アカウントにログインする",
  "password-change-fail": "パスワードリセットメールを再送してください",
  "password-change-fail-description": "パスワードリセットリンクの有効期限が切れているため、パスワードリセットを進めることができません。",
  "register-description": "こんにちは、{nickName}様！\n会員登録を完了してください",
  "register-country-select": "国/地域を選択してください。",
  "register-country-region": "国/地域を検索",
  "common-none-search-data": "該当する内容がございません。",
  "common-next": "次へ",
  "register-notifications-main-content": "最新のコンテンツ、イベント、ニュース、機能、チャレンジなど、コードプレッソの最新情報を受け取りたいですか？",
  "register-notifications-sub-content-1": "コードプレッソのメルマガを受け取りたい",
  "common-first-name": "名前",
  "common-placeholder-first-name": "名前を入力してください。",
  "error-first-name": "名前は1から25文字以内で入力してください。",
  "error-invalid-first-name": "名前が正しいかご確認ください。",
  "common-last-name": "姓",
  "common-placeholder-last-name": "姓を入力してください。",
  "error-last-name": "姓は1から25文字以内で入力してください。",
  "error-invalid-last-name": "姓が正しいかご確認ください。",
  "organization-create-title": "次に、組織を作成するかどうかを選択してください",
  "organization-create-option-1": "組織を作成",
  "organization-create-option-2": "組織を作成しない",
  "organization-create-description": "組織を作成すると、{username}さんに組織最高管理者権限が付与され、組織の運用を開始できます。",
  "common-organization-name": "組織名",
  "common-placeholder-organization-name": "組織名を入力してください。",
  "error-organization-name": "組織名は1〜50文字以内で入力してください。",
  "register-organization-size-title": "組織規模",
  "register-organization-size-select": "組織規模を選択してください。",
  "settings-title": "設定",
  "settings-logout": "ログアウト",
  "account-username": "ユーザー名",
  "account-organization": "組織",
  "account-none-organization": "どの組織にも所属していません",
  "account-country": "国/地域",
  "common-save": "保存",
  "account-change-success": "アカウントの変更が保存されました。",
  "account-change-fail": "アカウントの変更を保存できませんでした。\nもう一度お試しください。",
  "account-valid-name-size": "ユーザー名は2～25文字以内で入力してください。",
  "settings-account": "アカウント",
  "settings-notifications": "お知らせ",
  "account-delete": "アカウント削除",
  "account-my-delete": "マイアカウントを削除",
  "account-delete-agree-title": "アカウントを削除する前に規約を確認し同意してください。",
  "account-delete-agree-description": "匿名かされた情報以外のすべての個人情報は完全削除されます。\n詳細については、{linkDom}をご確認ください。",
  "account-delete-agree-info": "個人情報は完全削除され、統計目的で取集された情報は匿名化されて保持されることに同意します。",
  "account-delete-success": "アカウントが削除されました。",
  "account-delete-fail": "アカウントを削除できませんでした。\nもう一度お試しください。",
  "account-current-password": "現在のパスワード",
  "error-current-password": "現在のパスワードを入力する必要があります。",
  "error-password-incorrect": "現在のパスワードが正しいことを確認してください。",
  "password-saving-success": "パスワードが変更されました。",
  "password-saving-fail": "パスワードの変更を保存できませんでした。\nもう一度お試しください。",
  "notifications-agree-title": "コードプレッソのニュースを受け取る",
  "notifications-agree-content": "最新のコンテンツやイベント情報などコードプレッソのメルマガを受け取ることができます。",
  "notifications-change-success": "通知の変更が保存されました。",
  "notifications-change-fail": "通知の変更を保存できませんでした。\nもう一度お試しください。",
  "organization-members-management": "組織ユーザー管理",
  "account-delete-transfer-of-role-info": "アカウントを削除する前に、組織最高管理者権限を他の組織ユーザーに移譲してください。",
  "account-delete-info": "サブスクリプション終了後、アカウントを削除できます。",
  "organization-settings-title": "組織設定",
  "organization-create-button": "作成",
  "organization-create-success": "組織が作成されました。",
  "organization-create-fail": "組織を作成できませんでした。\nもう一度お試しください。",
  "organization-leave": "組織退会",
  "organization-my-leave": "マイ組織を退会",
  "organization-leave-transfer-of-role-info": "組織を退会する前に、組織最高管理者権限を他の組織ユーザーに移譲してください。",
  "organization-leave-info": "サブスクリプション終了後、組織を退会できます。",
  "organization-leave-title": "組織を退会しますか？",
  "organization-leave-info-1": "{OrganizationName}の組織に関連する機能は、もう利用できません。",
  "organization-leave-info-2-prefix": "",
  "organization-leave-info-2-suffix": "と入力すると、[退会]ボタンが有効になります。",
  "organization-leave-button": "退会",
  "organization-leave-success": "組織の退会が正常に完了しました。",
  "organization-leave-fail": "組織の退会を完了できませんでした。\nもう一度お試しください。",
  "organization-change-success": "組織の変更が保存されました。",
  "organization-change-fail": "組織の変更を保存できませんでした。\nもう一度お試しください。",
  "organization-Invite-members": "ユーザーを招待する",
  "organization-Invite-members-description": "入力されたメールアドレスに招待メールが送信されます。",
  "organization-menu-access": "メニューアクセス",
  "organization-role": "役割",
  "organization-role-select": "役割を選択してください。",
  "organization-role-administrator": "管理者",
  "organization-role-administrator-description": "この役割は、付与されたメニューアクセス権限のある機能を利用でき、組織情報を確認できます。",
  "organization-member-remove-title": "ユーザーを削除しますか？",
  "organization-member-remove-success": "ユーザーが正常に削除されました。",
  "organization-member-add": "ユーザーの追加",
  "organization-member-add-success": "ユーザーが追加されました。",
  "organization-Invite-members-success": "{Count}人のユーザーに招待メールが送信されました。",
  "organization-Invite-members-fail": "{Count}人のユーザーを招待できませんでした。\nもう一度お試しください。",
  "organization-Invite-members-email-error-1": "既に組織に所属しているメールアドレスです。",
  "organization-Invite-members-email-error-2": "既に招待されたメールアドレスです。",
  "organization-Invite-members-email-error-3": "重複して入力されたメールアドレスです。",
  "organization-Invite-members-menu-access-error": "少なくとも1つ以上のメニューを選択する必要があります。",
  "organization-member-count": "人のユーザー",
  "organization-member": "ユーザー",
  "organization-role-chief-administrator": "最高管理者",
  "organization-invited": "招待済み",
  "organization-active": "有効",
  "organization-last-accessed-date": "最近のアクセス日",
  "organization-transfer-of-role-button-1": "組織最高管理者権限の移譲",
  "organization-member-edit": "ユーザー編集",
  "organization-member-delete": "ユーザー削除",
  "organization-member-resend-email-description": "'{email}'さんに招待メールを再送信しますか？",
  "organization-member-resend-email-success": "'{email}'様への招待メールが再送信されました。",
  "organization-member-resend-email-fail": "'{email}'様への招待メールを再送信できませんでした。\nもう一度お試しください。",
  "organization-transfer-of-role-title": "組織最高管理者権限を移譲する前に同意してください",
  "organization-transfer-of-role-description": "権限を移譲すると、組織管理者となり、組織情報を編集できなくなります。",
  "organization-transfer-of-role-info": "組織最高管理者権限の移譲に同意します。",
  "organization-transfer-of-role-button-2": "権限を移譲する",
  "organization-transfer-of-role-success": "組織最高管理者権限が移譲されました。",
  "organization-transfer-of-role-fail": "組織最高管理者権限を移譲できませんでした。\nもう一度お試しください。",
  "organization-member-information": "ユーザー情報",
  "organization-member-information-success": "ユーザー情報が保存されました。",
  "organization-member-information-fail": "ユーザー情報を保存できませんでした。\nもう一度お試しください。",
  "organization-member-delete-title": "ユーザーを削除しますか？",
  "organization-member-delete-success": "ユーザーが正常に削除されました。",
  "organization-member-delete-fail": "ユーザーを削除できませんでした。\nもう一度お試しください。",
  "organization-invite-accept-fail": "{OrganizationName}に\n参加できませんでした",
  "organization-invite-accept-fail-content": "他の組織に所属している、またはエラーが発生したため、招待を受け入れることができません。\n現在の組織から退会した後に再度お試しいただくか、管理者に新しい招待メールを依頼してください。",
  "organization-invite-accept-success": "{OrganizationName}に\n参加しました",
  "organization-invite-accept-success-content": "今から{OrganizationName}の組織に関連する機能をご利用いただけます。",
  "organization-Invite-members-restriction-info": "ユーザー招待機能は、プロプランおよびエンタープライズプランでご利用いただけます。",
  "organization-subscription-management": "サブスクリプション管理",
  "organization-subscription-none-description-1": "まだサブスクリプション中のプランはありません。",
  "organization-subscription-none-description-2": "サービスを利用するには、サブスクリプションを開始してください。",
  "organization-subscription-none-button": "プランを見る",
  "organization-subscription-label-1": "利用中",
  "organization-subscription-label-2": "支払いが必要",
  "organization-subscription-label-3": "解約予定",
  "organization-subscription-label-4": "利用終了",
  "organization-subscription-manage": "管理",
  "organization-subscription-change-billing-cycle": "請求周期の変更",
  "organization-subscription-change-payment-method": "支払い方法の変更",
  "organization-subscription-coupon-management": "クーポン管理",
  "organization-subscription-cancel-subscription": "サブスクリプションを解約",
  "organization-subscription-change-billing-cycle-title": "請求周期を変更してもよろしいですか？",
  "organization-subscription-change-billing-cycle-description-1": "変更後",
  "organization-subscription-change-billing-cycle-description-2": "次回の請求から適用されます。",
  "organization-subscription-change-billing-cycle-button": "変更",
  "organization-subscription-change-billing-cycle-success": "請求周期の変更が完了しました。\n次回の請求から適用されます。",
  "organization-subscription-change-billing-cycle-fail": "請求周期の変更を完了できませんでした。\nもう一度お試しください。",
  "organization-subscription-change-billing-cycle-scheduled-1": "次回の請求から月額払いに変更予定",
  "organization-subscription-change-billing-cycle-scheduled-2": "次回の請求から年額払いに変更予定",
  "organization-subscription-cancel-change": "変更のキャンセル",
  "organization-subscription-applied": "適用済み",
  "organization-subscription-cancel-apply": "適用のキャンセル",
  "organization-subscription-change-payment-method-success": "支払い方法の変更が完了しました。",
  "organization-subscription-cancel-subscription-title": "サブスクリプションを解約しますか？",
  "organization-subscription-cancel-subscription-description-1": "解約後も{date}まで引き続きサービスをご利用いただけます。",
  "organization-subscription-cancel-subscription-description-3": "新規評価の作成および受験者の招待は制限されています。",
  "organization-subscription-cancel-subscription-description-4": "既存の評価とデータは保持されます。",
  "organization-subscription-cancel-subscription-description-5": "最高管理者以外の管理者アカウントは組織機能を利用できません。",
  "organization-subscription-cancel-subscription-success": "サブスクリプションの解約が完了しました。",
  "organization-subscription-cancel-subscription-fail": "サブスクリプションの解約を完了できませんでした。\nもう一度お試しください。",
  "organization-subscription-payment-failed": "決済失敗",
  "organization-subscription-payment-failed-description-1": "{date}までに決済が完了しない場合、ご利用が制限されます。",
  "organization-subscription-payment-failed-description-2": "自動決済を再試行中",
  "organization-subscription-retry-payment": "決済の再試行",
  "organization-subscription-retry-payment-title": "決済を再試行しますか？",
  "organization-subscription-retry-payment-description": "登録された決済方法で直ちに決済が実行されます。",
  "organization-subscription-retry-payment-success": "決済が完了しました。",
  "organization-subscription-retry-payment-fail": "決済を完了できませんでした。\nもう一度お試しください。",
  "payment-complete-next-billing-attempt-date": "次回の決済試行日",
  "organization-subscription-change-billing-cycle-scheduled-3": "次回の決済試行から月額払いに変更予定",
  "organization-subscription-change-billing-cycle-scheduled-4": "次回の決済試行から年額払いに変更予定",
  "organization-subscription-cancellation-pending-description": "{date}までご利用いただけます。\nそれ以降は自動的に終了し、料金は発生しません。",
  "organization-subscription-cancel-cancellation-request": "解約リクエストのキャンセル",
  "organization-subscription-cancel-cancellation-request-success": "解約リクエストのキャンセルが完了しました。",
  "organization-subscription-cancel-cancellation-request-fail": "解約リクエストのキャンセルを完了できませんでした。\nもう一度お試しください。",
  "organization-subscription-restart-subscription": "サブスクリプション再開",
  "organization-subscription-restart-subscription-title": "サブスクリプションを再開しますか？",
  "organization-subscription-restart-subscription-description-1": "再開するプラン",
  "organization-subscription-restart-subscription-description-2": "サブスクリプションを再開すると料金が発生し、\n再度サービスをご利用いただけます。",
  "organization-subscription-restart-subscription-success": "サブスクリプションが再開されました。",
  "organization-subscription-restart-subscription-fail": "サブスクリプションを再開できませんでした。\nもう一度お試しください。",
  "organization-subscription-end-subscription-description": "サブスクリプション再開時",
  "organization-subscription-change-billing-cycle-scheduled-5": "サブスクリプション再開時に月額払いに変更予定",
  "organization-subscription-change-billing-cycle-scheduled-6": "サブスクリプション再開時に年額払いに変更予定",
  "organization-subscription-contract-information": "契約情報",
  "organization-subscription-contract-end-date": "契約終了日",
  "organization-subscription-contract-end-date-description": "契約終了日後、組織の最高管理者を除く組織管理者の権限は削除されます。",
  "organization-subscription-payment-method": "請求方法",
  "organization-subscription-subject-to-contract": "契約に準ずる",
  "organization-subscription-renewal-method": "更新方法",
  "organization-subscription-negotiation": "協議",
  "organization-subscription-contract-end": "契約終了",
  "organization-subscription-contract-end-description-1": "契約が終了しました。",
  "organization-subscription-contract-end-description-2": "サービスを継続して利用するには、お問い合わせください。",
  "organization-subscription-coupon-management-tab-menu-1": "利用可能",
  "organization-subscription-coupon-management-tab-menu-2": "使用済み",
  "organization-subscription-coupon-management-tab-menu-3": "期限切れ",
  "organization-subscription-coupon-management-count": "00件のクーポン",
  "organization-subscription-coupon-management-apply-coupon": "クーポンを適用",
  "organization-subscription-coupon-management-none-1": "まだ利用可能なクーポンはありません。",
  "organization-subscription-coupon-management-none-2": "まだ使用済みまたは期限切れのクーポンはありません。",
  "organization-subscription-payment-history-count": "件の決済",
  "organization-subscription-payment-history-item": "項目",
  "organization-subscription-payment-history-invoice": "請求書",
  "organization-subscription-payment-history-none": "まだお支払い履歴はありません。",
  "organization-subscription-payment-history-canceled-date": "払い戻し処理日",
  "organization-subscription-payment-history-fully-canceled": "全額キャンセル",
  "organization-subscription-payment-history-partially-canceled": "一部キャンセル",
  "credit-title": "残りの評価招待クレジット:",
  "common-contact-us": "お問い合わせ",
  "credit-banner": "評価招待クレジット",
  "credit-detail-button": "詳細を見る",
  "credit-management": "クレジット管理",
  "credit-history-title": "評価招待クレジット処理履歴",
  "credit-history-count": "件の処理履歴",
  "credit-history-transaction": "処理履歴",
  "credit-history-granted": "付与",
  "credit-history-used": "使用",
  "credit-history-cancelled": "キャンセル",
  "credit-history-revoked": "回収",
  "credit-history-table-amount": "変動",
  "credit-history-table-remaining": "残り",
  "credit-history-table-related": "関連した",
  "credit-history-table-performed-by": "処理者",
  "credit-history-table-date": "日時",
  "credit-history-table-credit-expiration": "クレジット有効期限",
  "credit-history-table-revoked-reason-credit-expiration": "クレジットの有効期限切れにより自動回収",
  "credit-history-table-until": "{time}まで",
  "credit-history-table-revoked-reason-credit-refund": "払い戻しによる回収",
  "credit-history-table-usage-details": "使用詳細",
  "credit-history-table-cancellation-details": "キャンセル詳細",
  "credit-history-table-usage-details-info": "合計{count}個を使用",
  "credit-history-table-cancellation-details-info": "合計{count}個をキャンセル",
  "credit-history-table-candidate-credit-count": "受験者{candidateCount}名",
  "credit-history-table-candidate-credit-count-1": "1名あたり{creditCount}個",
  "credit-history-table-none-data": "まだ評価招待クレジットの処理履歴がありません。",
  "credit-limit-description": "評価招待クレジットが必要な場合は、{linkDom}メニューからご連絡ください。",
  "credit-certify-invitation-button": "クレジットの説明を見る",
  "credit-certify-invitation-limit": "評価招待クレジットが不足しているため、\n受験者を招待できません",
  "credit-history-table-none-related": "削除された評価",
  "credit-history-top-up-credits": "クレジットをチャージ",
  "credit-history-top-up-credits-count": "チャージするクレジット数",
  "credit-history-top-up-credits-count-error": "クレジット数は1～9,999の範囲で入力してください。",
  "credit-history-top-up-credits-description-1": "チャージクレジットには有効期限がなく、サブスクリプション終了後も消失しません。\nただし、サブスクリプション期間中のみ使用できます。",
  "credit-history-top-up-credits-description-2": "{link}に登録された支払い方法で決済が行われます。",
  "credit-history-top-up-credits-agree-check": "決済・クレジット利用条件および{term}に同意します。",
  "credit-history-top-up-credits-make-payment": "支払う",
  "credit-history-top-up-credits-success": "クレジットのチャージが完了しました。",
  "credit-history-top-up-credits-fail": "クレジットのチャージを完了できませんでした。\nもう一度お試しください。",
  "credit-history-top-up-credits-restriction-info-1-title": "サブスクリプション中のプランがないため、\nクレジットをチャージできません",
  "credit-history-top-up-credits-restriction-info-2-title": "サブスクリプションが終了したため、\nクレジットをチャージできません",
  "credit-history-top-up-credits-restriction-info-2-description": "サービスを継続して利用するには、サブスクリプションを再開してください。",
  "credit-history-top-up-credits-restriction-info-3-title": "エンタープライズプランでは、\nクレジットをチャージできません",
  "loading": "読み込み中です",
  "loading-title": "しばらくお待ちください。",
  "404-title": "ページが見つかりません",
  "404-content": "リクエストされたページが見つかりません。\n入力されたURLが正しいかご確認ください。",
  "error-button": "ホームへ移動",
  "500-title": "サーバー側にエラーが発生しました",
  "500-content": "サーバーが要求された操作を実行できません。\nしばらくしてから再試行してください。",
  "400-title": "ただいまメンテナンス中です",
  "400-content": "サービスご利用にご不便おかけし申し訳ございません。\nサービスアップデート作業を実施しております。\nサービス再開までもうしばらくお待ちください。",
  "dashboard-back-button": "ダッシュボードへ移動",
  "common-wrong-approach-title": "問題が発生しました",
  "common-wrong-approach-content": "しばらくしてからもう一度お試しください。",
  "common-ok": "確認",
  "learning-no-access-course": "受講コースへのアクセス権がありません",
  "learning-no-access-course-description": "コースを受講するには、先にコース登録を行ってください。",
  "learning-no-access-course-confirm": "トラックへ移動",
  "learning-exercise-refresh-page": "ページを更新してください",
  "learning-exercise-request-fail": "技術的なエラーのため、操作を行うことができません。\nページを再更新してみて、問題が解決しない場合は、{email} までお問い合わせください。",
  "learning-finished-course": "コース学習を完了しました。",
  "learning-finished-course-description": "トラックに戻り、学習結果を確認することができます。",
  "learning-back-to-track": "トラックへ移動",
  "learning-exercise": "練習問題",
  "common-hour": "時間",
  "common-min": "分",
  "common-s": "秒",
  "common-points": "ポイント",
  "learning-easy": "下",
  "learning-medium": "中",
  "learning-hard": "上",
  "learning-view-progress": "進捗を確認する",
  "learning-go": "移動",
  "learning-course-outline": "コース目次",
  "common-description": "説明",
  "learning-out-put": "実行結果",
  "learning-out-put-none-submit": "実行結果がなくても提出することができます。\n作成したコードを基準に採点します。",
  "learning-correct-answer": "正解",
  "learning-preview": "プレビュー",
  "common-course": "コース",
  "learning-skill-count": "{count}個のスキル",
  "learning-exercise-count": "{count}個の練習問題",
  "common-skill": "スキル",
  "learning-none-description": "この問題に提供される説明はございません。",
  "learning-out-put-info": "コード実行結果です。",
  "learning-error-info": "コードに誤りがあります。",
  "learning-error-description": "エラーの説明",
  "learning-submit-answer": "回答を提出する",
  "learning-submit-answer-info": "問題の回答を提出します。",
  "learning-exercise-finished": "練習問題を完了しました。",
  "learning-exercise-output-description": "解説を見る",
  "learning-output-description": "解説",
  "learning-exercise-complete-fail": "回答に誤りがあります。\nコードを再確認してください。",
  "learning-hint-widget-click": "ヒントを確認したい方は、こちらをクリックしてください。",
  "learning-exercise-incorrect-answer": "正解ではありません。",
  "learning-correct": "正解",
  "learning-activity-widget-drop-code-here": "ここに正しいコードを入力してください。",
  "learning-activity-widget-correct-code-herer": "ここに正しいコードを入力してください。",
  "learning-activity-widget-drag-and-drop-code": "正しいコードをドラッグ＆ドロップして空欄を埋めてください。",
  "learning-activity-widget-click-code": "正しいコードをクリックして空欄を埋めてください。",
  "learning-activity-widget-drag-and-drop-parts": "コードをドラッグ＆ドロップして正しい順序で配置してください。",
  "learning-activity-widget-click-parts": "コードをクリックして正しい順番に並び替えてください。",
  "learning-chart": "グラフ",
  "learning-lnstruction": "ご案内",
  "learning-multiple-choice": "選択式",
  "learning-short-answer-type": "短答式",
  "learning-essay-type": "記述式",
  "learning-answer-placeholder": "回答を入力してください。",
  "learning-show-correct-answer": "正解を確認",
  "learning-answer": "回答",
  "learning-annotation-widget-1": "ここにコードを書いてください",
  "learning-annotation-widget-2": "採点のため、以下のコードを修正しないでください",
  "learning-annotation-widget-3": "データの例",
  "learning-annotation-widget-4": "空欄に適切なコードを入力してください。",
  "learning-annotation-widget-5": "与えられた要件を満たすようにコードをリファクタリングしてください",
  "term-copyright": "ⓒ {year} Codepresso, Inc. All rights reserved. 無断での転載・複製・転用等は、法律により処罰される場合があります。",
  "learning-directory-select-files": "ディレクトリからファイルを選択してください。",
  "learning-reset-select-files": "初期化するファイルを選択してください",
  "common-reset": "初期化",
  "learning-reset-select-files-success": "選択したファイルが初期化されました。",
  "learning-reset-select-files-fail": "選択したファイルを初期化できませんでした。\nもう一度お試しください。",
  "learning-open-directory": "ディレクトリを開く",
  "learning-close-directory": "ディレクトリを閉じる",
  "learning-my-output": "私の実行結果",
  "learning-correct-output": "正解の実行結果",
  "learning-front-exercise-delay": "ユーザーのPC環境により、プレビューを確認するのに時間がかかることがあります。",
  "learning-front-exercise-download-fail": "実習に必要とされるインストールファイルのダウンロードに失敗しました。\nページを再更新してみて、問題が解決しない場合は、support@codepresso.io までお問い合わせください。",
  "learning-reset-editor": "エディターをリセットできます。",
  "learning-stop-code": "実行中止",
  "learning-file-count": "{count}個のファイル",
  "learning-copy-clipboard": "クリップボードにコピーされました。",
  "learning-limit-permission-title": "受講する権限がありません",
  "learning-limit-permission-description": "権限が必要な場合は、{link}メニューからご連絡ください。",
  "learning-hide-top-bottom-bars": "上部／下部バーを非表示",
  "learning-show-top-bottom-bars": "上部／下部バーを表示",
  "learning-front-preview-guide": "コード修正内容がプレビューに反映されました。",
  "challenges-title": "チャレンジ",
  "challenges-description": "様々な現場の技術的な課題を解決して、スキルアップしましょう。",
  "common-live": "進行中",
  "common-upcoming": "進行予定",
  "common-closed": "終了",
  "challenges-start-days": "{day}日後に開始",
  "challenges-start-tomorrow": "明日開始",
  "challenges-start-today": "本日開始",
  "challenges-closed-days": "{day}日後に終了",
  "challenges-closed-tomorrow": "明日終了",
  "challenges-closed-today": "今日終了",
  "challenges-entry-complete": "参加完了",
  "challenges-participants-count": "{totalCount}人の参加者",
  "challenges-certificate": "証書",
  "common-all": "すべて",
  "challenges-count": "個のチャレンジ",
  "common-filters": "フィルター",
  "challenges-none-data": "まだ登録されたチャレンジはありません。",
  "common-load-more": "もっと見る",
  "challenges-leaderboard-submitted-questions-showing-participants": "リーダーボードには、回答を提出完了した参加者のみ表示されます。",
  "common-period": "期間",
  "challenges-join-challenge": "チャレンジ参加",
  "common-overview": "概要",
  "challenges-leaderboard": "リーダーボード",
  "common-guidelines": "規則",
  "challenges-winner": "優勝者",
  "challenges-final-ranking-info": "最終順位とスコアは、採点後に表示されます。",
  "challenges-participant": "参加者",
  "common-delete-member": "退会したメンバー",
  "common-score": "スコア",
  "challenges-submit-questions": "提出済み問題数",
  "challenges-total-questions": "/ 全問題数",
  "challenges-last-submission": "最終提出日",
  "challenges-none-participants-data": "まだ参加者がいません。",
  "challenges-guidelines": "チャレンジの規則",
  "challenges-authentication-code-title": "認証コードを入力してください",
  "challenges-authentication-code-description": "チャレンジに参加するには、認証コードを入力してください。",
  "challenges-authentication-code-placeholder": "認証コード",
  "challenges-authentication-code-incorrect": "入力された認証コードが正しくありません。",
  "challenges-anti-cheating-guidance": "不正行為防止に関するご案内",
  "challenges-anti-cheating-info-1": "公平性を確保し、不正行為を防止するため、リアルタイムでの監視および記録が有効になっています。",
  "challenges-anti-cheating-info-2": "以下の行動は不正行為と見なされる可能性があるのでご注意ください。",
  "challenges-anti-cheating-screen-exit-detection": "画面を切り替える行為",
  "challenges-anti-cheating-screen-exit-detection-info-1": "2回以上発生すると、即時終了とさせていただきます。",
  "challenges-anti-cheating-screen-exit-detection-info-2": "問い合わせの送信や受験中に必要な操作など、やむを得ない事情による場合は、不利益は発生しません。安心して受験してください。",
  "challenges-anti-cheating-keyboard-shortcuts-restriction-and-detection": "許可されていないショートカットの使用を試みた行為",
  "challenges-anti-cheating-multiple-monitor-restriction-and-detection": "マルチモニターの使用を試みた行為",
  "challenges-anti-cheating-copy-cut-paste-detection": "外部のコードをコピー、切り取り、ペーストする行為",
  "challenges-anti-cheating-face-voice-recording": "カメラまたはマイクの設定を変更したり無効にしたりする行為",
  "challenges-anti-cheating-face-voice-recording-info-1": "カメラの視野が遮られている場合や、受験者を明確に確認できない場合も含まれます。",
  "challenges-agree-rules-title": "開始する前に規則に同意してください",
  "challenges-agree-rules-description": "規則を確認し、同意します。",
  "common-agree": "同意",
  "common-confirm": "確認",
  "challenges-proctoring-full-screen-error": "チャレンジを進行するには、画面全体を共有する必要があります。",
  "challenges-back-to-challenge-detail": "チャレンジ詳細へ移動",
  "challenges-finish-challenge-title": "チャレンジを終了しますか？",
  "common-cancel": "キャンセル",
  "challenges-finished-title": "チャレンジが終了しました",
  "challenges-finished-description": "チャレンジ時間が終了しました。\nチャレンジにご参加いただきありがとうございました。",
  "common-dashboard": "ダッシュボード",
  "common-skillCertify": "SkillCertify",
  "common-manageAssessment": "評価管理",
  "common-takeAssessment": "評価を受ける",
  "common-skillMonitor": "SkillMonitor",
  "common-skillAdvance": "SkillAdvance",
  "common-adaptiveLecture": "SkillFit",
  "advance-learn": "学習",
  "advance-practice": "練習",
  "common-choose-language": "言語選択",
  "dashboard-info-greetings": "こんにちは,",
  "dashboard-info-nickName": "{name}",
  "common-closed-assessment": "終了した評価数",
  "dashboard-total-assessments": "総評価数",
  "dashboard-completed-candidates": "完了した受験者数",
  "dashboard-total-candidates": "総受験者数",
  "dashboard-completed-learning": "完了した学習数",
  "dashboard-total-learning": "総学習数",
  "dashboard-learning-points": "学習ポイント",
  "dashboard-total-point": "総ポイント",
  "dashboard-completed-practice": "完了した練習数",
  "dashboard-total-practice": "総練習数",
  "dashboard-completed-assessments": "完了した評価数",
  "dashboard-created-assessments": "生成された評価",
  "dashboard-candidates": "受験者数",
  "common-sample": "サンプル",
  "skillCertify-none-created-assessment": "まだ生成された評価はありません。",
  "skillCertify-internal-assessment": "組織能力評価",
  "skillCertify-external-assessment": "外部人材評価",
  "dashboard-invited-assessments": "招待された評価",
  "dashboard-sample-assessments": "サンプル評価",
  "skillCertify-none-invited-assessment": "まだ招待された評価はありません。",
  "advance-my-learning": "マイ学習",
  "advance-my-learning-more": "マイ学習を見る",
  "advance-position-learn": "学習セッション",
  "advance-permission-disable": "受講する権限がありません。\n権限が必要な場合は、お問い合わせメニューからご連絡ください。",
  "advance-position-info": "コース & スキル情報",
  "advance-learn-none-data": "まだ開始した学習はありません。",
  "advance-my-practice": "マイ練習",
  "advance-my-practice-more": "マイ練習を見る",
  "advance-position-practice": "練習場所",
  "advance-practice-none-data": "まだ開始した練習はありません。",
  "advance-find-track": "トラックを探索する",
  "advance-my-learn-sub-description": "開始したすべての学習の概要です。",
  "common-in-progress": "進行中",
  "common-completed": "完了",
  "filter-field": "分野",
  "filter-select": "{count}個選択済み",
  "advance-my-practice-sub-description": "開始したすべての練習の概要です。",
  "advance-learn-sub-description": "技術を習得し、職務能力を高めてキャリアを発展させてください。",
  "advance-none-track": "まだ登録されたトラックがありません。",
  "advance-practice-sub-description": "練習評価を通じて技術や職務能力を確認してください。",
  "advance-level-count": "{count}個のレベル",
  "advance-course-count": "{count}個のコース",
  "advance-related-practice": "関連する練習",
  "advance-related-practice-info": "学習した内容をよく理解しているか確認してください。",
  "common-point-count": "{point}ポイント",
  "advance-not-start": "ロック",
  "advance-pre-start": "開始前",
  "advance-ongoing": "進行中",
  "advance-related-learn": "関連する学習",
  "advance-related-learn-info": "足りない部分を確認の上、改善してください。",
  "advance-my-level": "レベル {level}",
  "skillCertify-manage-assessment-description": "必要なカスタマイズ評価を簡単に生成し、既存の評価の修正、照会、削除などを簡単に行うことができます。",
  "skillCertify-search-placeholder": "評価名検索",
  "common-status": "ステータス",
  "skillCertify-assessment-count": "個の評価",
  "skillCertify-create-assessment": "評価生成",
  "common-information": "情報",
  "skillCertify-type": "タイプ",
  "common-question-info": "問題数",
  "common-question-count": "{count}個の問題",
  "common-duration": "評価時間",
  "skillCertify-more-information": "追加情報",
  "skillCertify-proctoring": "監督機能",
  "skillCertify-constructor": "生成者",
  "skillCertify-creation-date": "生成日",
  "skillCertify-tracks-settings": "トラック設定",
  "skillCertify-assessment-set-title-to-level-plural": "{title} - {level} 以外 {count}",
  "skillCertify-assessment-set-title-to-level-singular": "{title} - {level}",
  "skillCertify-tracks-information-detail": "トラック情報詳細",
  "skillCertify-pre-start": "評価開始前",
  "skillCertify-invited": "招待済み",
  "skillCertify-ready": "評価準備完了",
  "skillCertify-started": "評価開始",
  "skillCertify-completed": "評価完了",
  "skillCertify-view-actual-question": "実践問題を見る",
  "skillCertify-actual-question": "実践問題",
  "skillCertify-api-reference": "参考資料",
  "skillCertify-api-reference-description": "この設定を有効にすると、受験者は評価中に参考資料を確認することができます。",
  "skillCertify-api-reference-view": "参考資料を見る",
  "skillCertify-add-track": "トラックの追加",
  "skillCertify-add-track-success": "トラックが追加されました。",
  "skillCertify-set-tip": "レベルを選択してください。",
  "skillCertify-recommend-time": "推奨時間",
  "skillCertify-recommend-time-tip": "トラックを解くのに推奨される時間です。",
  "skillCertify-remove-track": "トラックの削除",
  "skillCertify-track-remove-title": "トラックを削除しますか？",
  "common-remove": "削除",
  "skillCertify-remove-track-success": "トラックが正常に削除されました。",
  "skillCertify-reset-track": "トラックの初期化",
  "skillCertify-category": "カテゴリー",
  "advance-track-name-placeholder": "トラック名を検索する",
  "advance-track-count": "個のトラック",
  "advance-track": "トラック",
  "skillCertify-view-description": "説明を見る",
  "advance-more-track": "詳細を見る",
  "skillCertify-view-guide": "ガイドを見る",
  "advance-guide": "ガイド",
  "advance-level": "レベル",
  "advance-level-general": "共通",
  "advance-level-entry": "スターター",
  "advance-level-beginner": "ビギナー",
  "advance-level-intermediate": "ミドル",
  "advance-level-professional": "エキスパート",
  "skillCertify-view-questions": "問題を見る",
  "skillCertify-select": "選択",
  "skillCertify-select-info": "複数のランク別問題セットの中から、1つのセットがランダムに選ばれます。",
  "skillCertify-basic-info": "基本情報",
  "skillCertify-assessment-name": "評価名",
  "skillCertify-assessment-name-placeholder": "評価名を入力してください。",
  "skillCertify-assessment-internal": "組織能力評価",
  "skillCertify-assessment-external": "外部人材評価",
  "skillCertify-assessment-internal-description": "組織能力評価は、組織診断を通じた従業員の能力把握、人事管理などに活用できます。",
  "skillCertify-assessment-external-description": "外部人材評価を活用することで、人材採用、協力会社の選定など、組織外の人の能力を評価することができます。",
  "skillCertify-period-info": "受験者は設定した期間内に受験していただく必要があります。",
  "common-open-date": "開始日",
  "common-at": "",
  "common-close-date": "終了日",
  "skillCertify-period-error-invalid-both": "終了日と終了時間は、開始日と開始時間より早く設定することができません。",
  "skillCertify-time-zone": "時間帯",
  "skillCertify-time-zone-placeholder": "時間帯を検索",
  "common-optional": "オプション | - オプション",
  "skillCertify-candidates-find-tip": "受験者は評価について詳細を確認することができます。",
  "skillCertify-assessment-description-placeholder": "評価に関する説明を入力してください。",
  "skillCertify-assessment-duration-tip": "トラックに合わせて評価時間が自動的に設定され、必要に応じて評価時間を調整することができます。",
  "skillCertify-assessment-duration-time-limit": "時間制限",
  "common-duration-unlimited": "無制限",
  "skillCertify-assessment-duration-error": "評価時間を入力する必要があります。",
  "skillCertify-assessment-duration-change": "評価時間が以前の設定に基づいて調整されました。",
  "common-previous": "戻る",
  "skillCertify-proctoring-description": "公平性を確保し、不正行為を防止するために、監督機能を使用することをお勧めします。",
  "skillCertify-no-proctoring": "使用しない",
  "skillCertify-basic-proctoring": "基本",
  "skillCertify-basic-proctoring-sub": "ウェブブラウザ",
  "skillCertify-advanced-proctoring": "強化",
  "skillCertify-advanced-proctoring-sub": "Proctiveプログラム",
  "skillCertify-proctoring-screen-exit-detection": "画面離脱の検出",
  "skillCertify-proctoring-screen-exit-detection-description": "評価中に画面から離れた場合を検出できます。",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection": "ショートカットの制限および検出",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-1": "評価中は許可されていないショートカットの使用が制限され、使用を試みた場合には検出できます。",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-2": "許可されていないショートカット:",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-3": "ウェブページの保存、スクリーンショット、ソースの表示、開発者ツールの起動に関連するショートカット",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection": "マルチモニターの制限および検出",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection-description": "評価中はマルチモニターの使用が制限され、使用を試みた場合には検出できます。",
  "skillCertify-proctoring-copy-cut-paste-detection": "コピー／切り取り／ペーストの検出",
  "skillCertify-proctoring-copy-cut-paste-detection-description": "評価中にコードやテキストをコピー、カット、またはペーストした場合を検出できます。",
  "skillCertify-proctoring-partial-screen--recording": "画面部分録画（不正行為発生時）",
  "skillCertify-proctoring-partial-screen--recording-description-1": "評価中に不正行為が発生した時点の画面が記録されます。",
  "skillCertify-proctoring-partial-screen--recording-description-2": "不正行為が検出されると、複数のスクリーンショットがキャプチャされ、それらを基に不正行為ごとに個別の動画が生成されます。",
  "skillCertify-proctoring-partial-screen--recording-description-3": "録画された動画は安全に保存され、30日後に完全に削除されます。",
  "skillCertify-proctoring-partial-screen--recording-description-4": "録画された動画は、管理者による採点後に確認できます。",
  "skillCertify-proctoring-full-screen-recording": "画面全体録画（評価全過程）",
  "skillCertify-proctoring-full-screen-recording-description-1": "評価の開始から終了まで画面が録画されます。",
  "skillCertify-proctoring-full-screen-recording-description-2": "不正行為が発生した時点が記録され、録画された動画から該当箇所を確認できます。",
  "skillCertify-proctoring-face-voice-recording": "顔/音声の録画",
  "skillCertify-proctoring-face-voice-recording-description-1": "評価を開始する前に、カメラとマイクの設定が必要です。",
  "skillCertify-proctoring-face-voice-recording-description-2": "評価中は受験者の顔と音声が録画されます。",
  "skillCertify-assessment-create-success": "評価が生成されました。",
  "skillCertify-assessment-create-fail": "評価を生成できませんでした。\nもう一度お試しください。",
  "skillCertify-assessment-info": "評価情報",
  "skillCertify-candidates-list": "受験者リスト",
  "common-delete": "削除",
  "skillCertify-assessment-delete-title": "評価を削除しますか？",
  "skillCertify-assessment-delete-info-1": "すべての受験者者の評価結果も削除されます。",
  "skillCertify-assessment-delete-info-2": "'削除'と入力すると、[削除] ボタンが有効になります。",
  "skillCertify-assessment-delete-success": "評価が正常に削除されました。",
  "skillCertify-assessment-delete-fail": "評価を削除することができません。\nもう一度お試しください。",
  "common-modify": "修正",
  "skillCertify-modify-limit-title": "評価を修正できません",
  "skillCertify-modify-limit-description": "評価を開始した受験者がいるため、評価を修正できません。",
  "common-update": "更新する",
  "skillCertify-modify-success": "評価が更新されました。",
  "skillCertify-modify-fail": "評価を更新できませんでした。\n再試行してください。",
  "common-invite": "招待する",
  "skillCertify-invite-candidates": "受験者を招待する",
  "skillCertify-invite-candidates-description": "メールアドレスはコンマまたはEnterキーで追加できます。\n受験者が評価を開始した場合、評価を修正することはできません。",
  "skillCertify-invite-candidates-email-invalid": "'{email}'は無効なメールです。",
  "skillCertify-invite-candidates-success": "{count}人の受験者に評価招待メールが送信されました。",
  "skillCertify-invite-candidates-fail": "{count}人の受験者を招待できませんでした。\nもう一度お試しください。",
  "skillCertify-invite-candidates-duplicate-count": "すでに{count}名の受験者が招待されています\n重複を削除してから招待しますか？",
  "skillCertify-invite-candidates-duplicate-description": "重複を削除した後、新規受験者だけが招待されます。",
  "skillCertify-invite-candidates-duplicate-warning": "既に招待された受験者がいます。",
  "learning-start-assessment": "評価開始",
  "skillCertify-search-user-placeholder-new": "氏名またはメール検索",
  "skillCertify-candidate-report": "レポート",
  "skillCertify-score-rank": "スコア順位",
  "skillCertify-skill-acquisition-rate-rank": "スキル保有率順位",
  "skillCertify-set-average-skill-acquisition-rate-info": "すべてのトラックの平均スキル保有率です。",
  "skillCertify-candidate-tracks-result-button": "トラック結果データを見る",
  "skillCertify-assessment-score-rank": "評価スコア順位",
  "skillCertify-assessment-score": "評価スコア",
  "skillCertify-assessment-time-taken": "評価所要時間",
  "skillCertify-assessment-skill-acquisition-rate-rank": "評価スキル保有率順位",
  "skillCertify-assessment-skill-acquisition-rate": "評価スキル保有率",
  "profile-full-name": "氏名",
  "common-link-copy": "リンクをコピーしました。",
  "skillCertify-candidate-count": "人の受験者",
  "skillCertify-candidate-info": "受験者情報",
  "skillCertify-candidate-last-record": "最近の記録",
  "skillCertify-candidate-invited-date": "招待日",
  "skillCertify-candidate-ready-date": "評価準備完了日",
  "skillCertify-candidate-started-date": "評価開始日",
  "skillCertify-candidate-completed-date": "評価完了日",
  "common-time-taken": "所要時間",
  "common-view": "表示",
  "skillCertify-rank": "順位",
  "skillCertify-candidate-resend-email": "メール再送信",
  "skillCertify-candidate-resend-email-description": "'{email}'さんに評価招待メールを再送信しますか？",
  "common-resend": "再送信",
  "skillCertify-candidate-resend-email-success": "'{email}'様への評価招待メールが再送信されました。",
  "skillCertify-candidate-resend-email-fail": "'{email}'様への評価招待メールを再送信できませんでした。\nもう一度お試しください。",
  "skillCertify-set-average-score-info": "すべてのトラックの平均スコアです。",
  "skillCertify-action-timeline": "タイムライン",
  "skillCertify-action-record-count": "個の記録",
  "skillCertify-candidate-assessment-result": "評価結果",
  "skillCertify-score-grading": "採点中",
  "skillCertify-score-none-description": "管理者が採点をしているため、結果が表示されるまでお待ちください。",
  "skillCertify-candidate-report-button": "レポートを見る",
  "common-read-more": "もっと見る",
  "skillCertify-candidate-none-data": "受験者がいません。",
  "skillCertify-candidate-select": "{count}人の受験者選択済み",
  "skillCertify-delete-candidates": "受験者削除",
  "skillCertify-candidate-delete-1": "人の受験者を削除しますか？",
  "skillCertify-candidate-delete-2": "",
  "skillCertify-candidate-delete-description": "受験者の評価結果も削除されます。",
  "skillCertify-candidate-delete-success": "{count}人の受験者が正常に削除されました。",
  "skillCertify-candidate-delete-fail": "{count}人の受験者を削除できませんでした。\nもう一度お試しください。",
  "learning-view-guidelines": "規則を見る",
  "learning-continue-assessment": "評価続行する",
  "skillCertify-account-miss-match": "アカウント情報が一致しないため、アクセスできません",
  "skillCertify-account-miss-match-description": "現在ログインしているアカウントと招待メールを受け取ったアカウントが一致しません。\nログアウトして再度ログインしてください、問題が解決しない場合は、管理者にお問い合わせください。",
  "skillCertify-limit-permission-title": "評価を進めるアクセス権がありません",
  "skillCertify-limit-permission-description": "権限が必要な場合は、管理者にお問い合わせください。",
  "skillCertify-assessment-duration-guide": "評価開始前に残り時間をご確認ください",
  "skillCertify-assessment-duration-description-1": "評価終了日によって評価時間が設定されます。",
  "skillCertify-assessment-duration-description-2": "設定される評価時間 : {hour}時間 {minute}分",
  "skillCertify-assessment-guidelines": "評価規則",
  "learning-assessment-guide-line-description-1": "本{target}は{element}ブラウザーを使用してご参加ください。",
  "learning-assessment-guild-line-element-1": "Google Chrome",
  "learning-assessment-guide-line-description-2": "問題の全体または一部をコピーしたり、スクリーンショットを撮る行為は禁止されています。",
  "learning-assessment-guide-line-description-3": "試験問題や自分の回答に関連する情報をインターネットに投稿したり、他人と共有はお控えください。",
  "learning-assessment-guide-line-description-4": "{target}中にあり得る技術的な問題や、指示に従わなかったことによるペナルティーについては、当方は責任を負いません。",
  "learning-assessment-guide-line-description-5": "安定したインターネット環境がある場所で{target}に参加してください。カフェや図書館などの公共ネットワークの使用は推奨されておりません。",
  "learning-assessment-guide-line-description-6": "{target}時間の管理は参加者自身の責任となります。{target}時間内までに提出されなかった場合、不利益が科される場合があります。",
  "learning-assessment-guide-line-description-7": "実習中にコードの保存機能を使用できます。\nコードの保存のショートカットは次の通りです。{element}",
  "learning-assessment-guild-line-element-2": "Windows ユーザー: Ctrl + S",
  "learning-assessment-guild-line-element-3": "MacBookおよびiMacのユーザー: Command + S",
  "learning-assessment-guide-line-description-8": "ChatGPTなどの類似のプログラムを使用した場合、ゼロ点になる可能性があります。これは不正行為防止及び検知ソリューションで、検知、確認されます。",
  "learning-assessment-guide-line-description-9": "{target}中に不正行為が発生した場合、このシステムによって記録され、管理者に報告される可能性があります。",
  "learning-assessment-guide-line-description-10": "不正行為防止及び検知ソリューションが使用されていない場合や、試験中に中断された場合、結果が無効になる可能性があります。",
  "learning-assessment-guide-line-description-for-mac-1": "不正行為防止および検知ソリューションを使用するために、MacBookおよびiMacのユーザーは画面収録のアクセス権を設定する必要があります。",
  "learning-assessment-guide-line-description-for-mac-2": "設定の手順は次のとおりです。",
  "learning-assessment-guide-line-description-for-mac-3": "Appleメニュー → システム環境設定 → セキュリティとプライバシー → 画面収録 → 錠を解除 → Google Chromeをチェック → ブラウザを再起動",
  "learning-assessment-guide-line-description-for-mac-4": "Appleメニュー → システム環境設定 → セキュリティとプライバシー → 画面収録 → 錠を解除 → Proctiveをチェック → Proctiveを再起動",
  "learning-assessment-guide-line-description-11": "不正行為防止及び検知ソリューションの指示に従わなかったことによるペナルティーは、参加者自身の責任となります。",
  "common-question": "問題",
  "skillCertify-assessment-outline": "評価目次",
  "skillCertify-assessment": "評価",
  "skillCertify-api-reference-info": "参考資料を確認することができます。",
  "common-description-button": "詳細を見る",
  "learning-finish": "評価を終了する",
  "skillCertify-assessment-finish-question-title": "評価を終了しますか？",
  "skillCertify-assessment-finish-question-description-success-submitted": "すべての回答が提出されました。",
  "skillCertify-assessment-finish-question-description-not-submitted": "まだ提出していない回答がありますので、提出してください。",
  "skillCertify-assessment-finish-question-description-common": "今すぐ評価を終了すると、これ以上評価を見たり修正したりすることができません。",
  "skillCertify-assessment-finish-question-description-check": "もう一度確認してください。",
  "skillCertify-assessment-finish-question-button": "終了する",
  "skillCertify-caution": "注意",
  "skillCertify-caution-tab-switch": "画面から外れた行動が確認されました。\n管理者に報告されるので、完了するまで画面から離れないでください。",
  "common-continue": "続行する",
  "skillCertify-caution-tab-toast": "管理者に報告されるので、完了するまで画面から離れないでください。",
  "skillCertify-caution-short-cut-1": "許可されていないショートカットを使用した行動が確認されました。\n管理者に報告されるので、完了するまで許可されていないショートカットを使用しないでください。",
  "skillCertify-caution-short-cut-2": "以下の行動に関連するショートカットキーは許可されていません。",
  "skillCertify-caution-short-cut-key-word-1": "ウェブページの保存",
  "skillCertify-caution-short-cut-key-word-2": "スクリーンショット",
  "skillCertify-caution-short-cut-key-word-3": "ソースの表示",
  "skillCertify-caution-short-cut-key-word-4": "開発者ツールの起動",
  "skillCertify-caution-short-cut-toast": "管理者に報告されるので、完了するまで許可されていないショートカットを使用しないでください。",
  "skillCertify-caution-multiple-monitor": "マルチモニターを使用した行動が確認されました。\n管理者に報告されるので、完了するまでマルチモニターを使用しないでください。",
  "skillCertify-proctoring-face-voice-recording-no-detect-title": "カメラまたはマイクが検出されません",
  "skillCertify-proctoring-face-voice-recording-no-detect-description": "監督機能が中断されたため、続行できません。\n最初の画面に戻り、カメラとマイクを再設定してから続行してください。",
  "skillCertify-proctoring-face-voice-recording-no-detect-button": "最初の画面へ移動",
  "hands-on-environment-setup-loading": "実習環境をセットアップしています。",
  "hands-on-environment-setup-loading-title": "しばらくお待ちくださいませ。",
  "hands-on-environment-setup-completed": "実習環境のセットアップが完了しました。",
  "hands-on-environment-setup-completed-info": "下のボタンをクリックして実習環境を進めてください。",
  "hands-on-environment-setup-completed-button": "実習環境へ進める",
  "hands-on-environment-setup-failed": "実習環境のセットアップに失敗しました。",
  "hands-on-environment-setup-failed-info": "下のボタンをクリックして実習環境のセットアップを再試行してください。",
  "hands-on-environment-setup-failed-button": "実習環境のセットアップを再試行",
  "hands-on-environment-setup-description": "実習環境のセットアップには、{time}ほどかかる場合があります。",
  "hands-on-environment-setup-description-time": "約{time}分",
  "embed-provisioning-phase-queued": "利用可能なリソースを待っています…",
  "embed-provisioning-phase-launching": "実習環境を起動しています…",
  "embed-provisioning-expired-info": "予想より時間がかかっています。もう一度お試しください。",
  "embed-provisioning-still-preparing": "環境をまだ準備しています。しばらくお待ちいただくか、再試行してください。",
  "learning-run-code-and-save": "実行および保存",
  "learning-rerun-and-save": "再実行および保存",
  "learning-saved": "保存されました。",
  "learning-save-failed": "保存に失敗しました。",
  "skillCertify-end-time-info-title": "評価終了まで残り{minutes}分です\n回答を提出したかもう一度ご確認ください",
  "skillCertify-end-time-info-description": "まだ提出していない回答があれば、提出してください。",
  "skillCertify-assessment-finish-title": "評価が終了しました",
  "skillCertify-assessment-finish-description": "評価時間が終了しました。\n評価にご参加いただきありがとうございました。",
  "learning-fail-message": "一時的なエラーのため、提出できません。",
  "learning-fail-message-retry": "もう一度お試しください。",
  "skillCertify-assessment-completed-title": "管理者に提出された回答が提出されました",
  "skillCertify-assessment-completed-description": "これまでの経験とスキルを分かるようにプロフィールを設定してください。",
  "skillCertify-assessment-completed-go-profile": "プロフィールへ移動",
  "skillCertify-load-template": "テンプレートを開く",
  "skillCertify-template": "テンプレート",
  "skillCertify-template-none-save-data": "まだ保存されたテンプレートがありません。",
  "common-apply": "適用",
  "skillCertify-template-load-title": "このテンプレートを開きますか？",
  "skillCertify-template-load-info": "既に設定されているトラックは削除され、選択したテンプレートのトラックに置き換えられます。",
  "skillCertify-template-load-success": "テンプレートが適用されました。",
  "skillCertify-save-template": "テンプレートとして保存",
  "skillCertify-template-save-title": "このトラックをテンプレートとして保存しますか？",
  "skillCertify-template-save-info-1": "保存されたテンプレートは{element}に利用できます。",
  "skillCertify-template-save-info-2": "評価生成および修正時",
  "skillCertify-template-name-placeholder": "テンプレート名を入力してください。",
  "skillCertify-error-template-name": "テンプレート名は1から30文字以内である必要があります。",
  "skillCertify-template-save-success": "テンプレートが正常に保存されました。",
  "skillCertify-template-save-fail": "テンプレートを保存できませんでした。\nもう一度お試しください。",
  "skillCertify-template-management": "テンプレート管理",
  "skillCertify-search-template-name-placeholder": "テンプレート名検索",
  "skillCertify-template-edit-title": "テンプレート名を編集しますか？",
  "skillCertify-template-edit-success": "テンプレート名が編集されました。",
  "skillCertify-template-edit-fail": "テンプレート名を編集できませんでした。\nもう一度お試しください。",
  "skillCertify-template-delete-title": "このテンプレートを削除しますか？",
  "skillCertify-template-delete-success": "テンプレートが正常に削除されました。",
  "skillCertify-template-delete-fail": "テンプレートを削除できませんでした。\nもう一度お試しください。",
  "skillCertify-caution-multiple-monitor-title": "モニターの設定を確認してください",
  "skillCertify-caution-multiple-monitor-description": "マルチモニターの使用は不正行為と判断される恐れがあります。\n接続を解除した上、お進みください。",
  "skillCertify-caution-multiple-monitor-enable": "マルチモニターが接続されておりません",
  "skillCertify-caution-multiple-monitor-disable-1": "マルチモニターが接続されています",
  "skillCertify-caution-multiple-monitor-disable-2": "（接続解除必要）",
  "skillCertify-caution-recording-title": "録画に同意してください",
  "skillCertify-caution-recording-description-basic": "不正行為を防ぐために、画面が録画されます。\n録画された動画は安全に保存され、30日後に完全に削除されます。",
  "skillCertify-caution-recording-agree-basic": "画面の録画に同意します。",
  "skillCertify-caution-recording-description": "不正行為を防ぐために、画面と顔/音声が録画されます。\n録画された動画は安全に保存され、30日後に完全に削除されます。",
  "skillCertify-caution-recording-agree": "画面と顔/音声の録画に同意します。",
  "skillCertify-install-proctoring-program-title": "Proctiveをインストールしてください",
  "skillCertify-install-proctoring-program-description": "続行するには、監督プログラムのインストールが必要です。\n以下のリンクからインストールしてください。",
  "skillCertify-install-proctoring-program-description-bold": "インストール後はこのウィンドウを閉じて、再度お試しください。",
  "skillCertify-update-proctoring-program-title": "Proctiveを更新してください",
  "skillCertify-update-proctoring-program-description": "続行するには、監督プログラムの更新が必要です。\n以下のリンクから更新してください。",
  "skillCertify-basic-proctoring-recording-fail-title": "録画が正常に行われていません",
  "skillCertify-basic-proctoring-recording-fail-description": "録画が正常に行われていないため、評価を続行することはできません。\nもう一度お試しのうえ、問題が解決しない場合は、{email} までお問い合わせください。",
  "skillCertify-proctoring-recording-fail-title": "録画が正常に行われていません\n以下の内容をご確認後、Proctiveを再実行してください",
  "skillCertify-proctoring-recording-fail-description": "カメラとマイクの権限または接続状況を確認",
  "skillCertify-proctoring-face-voice-recording-set-up-title": "カメラとマイクを設定してください",
  "skillCertify-proctoring-face-voice-recording-set-up-camera": "カメラ",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone": "マイク",
  "skillCertify-proctoring-face-voice-recording-set-up-retry": "リトライ",
  "skillCertify-proctoring-face-voice-recording-set-up-retry-description": "カメラとマイクの接続を再確認します。",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-title": "カメラとマイクの接続に失敗しました",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-description": "カメラとマイクの権限または接続状況を確認してください。",
  "skillCertify-proctoring-screen-record-title": "画面全体を共有してください",
  "skillCertify-proctoring-full-screen-error": "評価を進行するには、**画面全体**を共有する必要があります。",
  "skillCertify-proctoring-entire-screen-recording-no-access-title": "画面録画を開始できません\n以下の内容をご確認ください",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-1": "画面収録のアクセス権が設定されているか確認",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-2": "スクリーンショットのブロックや画面録画の防止を行うソフトウェアが実行されていないか確認",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-3": "問題が解決しない場合は、{email} までお問い合わせください。",
  "skillCertify-aws-label": "AWS",
  "skillCertify-web-ide-label": "Web IDE",
  "skillCertify-prompt-label": "Prompt",
  "skillCertify-agent-prompt-label": "Agent Prompt",
  "skillCertify-command-multiple-choice-label": "コマンド&選択式",
  "skillCertify-command-label": "コマンド",
  "skillCertify-code-no-run-code-label": "コード実習（実行なし）",
  "skillCertify-command-short-answer-label": "コマンド&短答型",
  "skillCertify-code-label": "コード実習",
  "skillCertify-multiple-files-code-label": "マルチファイルコード実習",
  "skillCertify-jupyter-notebook-label": "Jupyter Notebook",
  "skillCertify-coding-agent-label": "Coding Agent",
  "skillCertify-take-assessment-description": "招待されたすべての評価とサンプル評価の概要です。",
  "skillCertify-sample-information-title": "サンプル評価を開始する前に案内事項を確認してください",
  "skillCertify-sample-information-new-description-1": "サンプル評価は、監督機能または問題タイプを事前に体験するための評価であり、正解や結果は提供されません。",
  "skillCertify-sample-information-new-description-2": "監督機能によって発生する録画および行動履歴は保存されず、管理者にも報告されません。",
  "skillCertify-sample-information-new-description-3": "コード実習のサンプル評価は、実際の評価とは異なるプログラミング言語で提供される場合があります。",
  "skillCertify-sample-information-new-description-4": "招待された評価を受験する前まで、サンプル評価を体験できます。（評価終了後はご利用いただけません）",
  "skillCertify-sample-unavailable-description": "現在サンプル評価を体験できません。\n進行予定または進行中の評価に招待されると体験できます。",
  "skillCertify-sample-token-limit-info": "この評価はトークン使用量が制限されており、上限に達すると応答の生成が停止します。",
  "skillCertify-sample-assessment-completed-title": "サンプル評価を完了しました",
  "skillCertify-sample-assessment-completed-description": "再受験するか、別のサンプル評価を体験してみてください。",
  "skillCertify-sample-assessment-completed-try-sample-assessment": "サンプル評価を体験する",
  "skillCertify-command-question-type": "問題タイプ",
  "skillCertify-command-basic-proctoring-label": "基本監督",
  "skillCertify-command-advanced-proctoring-label": "強化監督",
  "skillCertify-proctoring-screen-record-description-3": "録画された動画は30日後に永久に削除されます。",
  "common-retry": "試行",
  "assessment-provision-failed": "実習環境の準備に失敗しました。\nもう一度お試しいただくか、問題が続く場合はお問い合わせください。",
  "skillCertify-advanced-proctoring-restriction-info": "強化監督は、プロプランおよびエンタープライズプランでご利用いただけます。",
  "skillCertify-advanced-proctoring-restriction-info-2": "強化監督のご利用をご希望の場合は、専任マネージャーまでお問い合わせください。",
  "skillCertify-report-language-tip": "選択した言語で評価レポートと受験者レポートが生成されます。",
  "skillCertify-report-language-info-1": "ベーシックプランでは言語を1つのみ選択できます。",
  "skillCertify-report-language-info-2": "プロおよびエンタープライズプランでは、追加の言語を選択できます。",
  "skillCertify-creation-restriction-info-1-title": "サブスクリプション中のプランがないため、\n評価を作成できません",
  "skillCertify-creation-restriction-info-2-title": "サブスクリプションが終了したため、\n評価を作成できませんㅁ",
  "credit-certify-creation-limit-description-1": "評価招待クレジットが必要な場合は、{linkDom}で追加購入できます。",
  "credit-certify-creation-limit-description-2": "クレジット管理へ",
  "credit-certify-creation-limit-button": "クレジット管理へ移動",
  "credit-certify-invitation-restriction-info-title": "サブスクリプションが終了したため、\n受験者を招待できません",
  "skillCertify-assessment-time-added": "{minutes}分追加済み",
  "skillCertify-assessment-time-extension-history": "時間追加履歴",
  "skillCertify-assessment-total-added-time": "合計追加時間",
  "skillCertify-assessment-time-added-toast": "評価時間が{minutes}分追加されました。",
  "skillCertify-core-label": "Core",
  "skillCertify-e2e-label": "E2E",
  "skillCertify-aI-fluent-label": "AI Fluent",
  "skillCertify-plan-restriction-info": "プロ / エンタープライズプラン専用",
  "skillCertify-calculation-basis": "算定基準",
  "skillCertify-credit": "クレジット",
  "skillCertify-track-count": "{count}個",
  "skillCertify-credit-count": "{count}個",
  "skillCertify-credit-info": "受験者1名を招待すると、評価招待クレジット",
  "skillCertify-credit-info-1": "{count}個",
  "skillCertify-credit-info-2": "を使用予定",
  "skillCertify-select-disabled-info-1": "CoreまたはE2Eトラックが選択されているため、AI Fluentトラックを選択できません。",
  "skillCertify-select-disabled-info-1-1": "AI Fluentトラックは単独でのみ構成できます。",
  "skillCertify-select-disabled-info-2": "AI Fluentトラックが選択されているため、他のトラックを選択できません。",
  "skillCertify-select-disabled-info-2-1": "AI Fluentトラックは単独でのみ構成できます。",
  "skillCertify-tracks-settings-disabled-info-1": "受験者を招待した後は、トラックを変更できません。",
  "skillCertify-tracks-settings-disabled-info-2": "基本情報と監督機能は次のステップで修正でき、招待された受験者をすべて削除すると、トラックも再度変更できます。",
  "skillCertify-invite-candidates-candidate-count": "受験者{count}名を招待",
  "skillCertify-invite-candidates-credit-count": "クレジット{count}個を使用予定",
  "skillCertify-invite-candidates-credit-count-per-candidate": "1名あたり{count}個を使用予定",
  "skillCertify-invite-candidates-estimated-remaining": "招待後の予想残り",
  "skillCertify-invite-candidates-insufficient-credits": "不足しているクレジット",
  "skillCertify-calculation-basis-track-count": "設定したトラック数",
  "skillCertify-calculation-basis-credit-count": "消費されるクレジット数",
  "webcam-recording-active": "ウェブカメラ録画中",
  "SkillCertify-duplicate-session-warning-title": "別の画面で評価が開始されました",
  "SkillCertify-duplicate-session-warning-description": "現在の画面では、これ以上評価を続行できません。",
  "skillCertify-tracks-setup-method": "トラック設定方式",
  "skillCertify-tracks-setup-manual": "手動設定",
  "skillCertify-tracks-select-manually": "トラックを直接選択",
  "skillCertify-tracks-ai-recommendation": "AI推奨",
  "skillCertify-tracks-get-recommendation": "トラックの推奨を受ける",
  "skillCertify-tracks-setup-method-change-title": "トラック設定方式を変更しますか？",
  "skillCertify-tracks-setup-method-change-description": "現在設定されているトラックが初期化されます。",
  "skillCertify-tracks-recommendation-input-guide": "トラックの推奨に必要な情報を入力してください。",
  "skillCertify-tracks-recommendation-credit-info": "推奨を受けると、AI推奨回数が1回消費されます。",
  "skillCertify-tracks-recommendation-monthly-limit-basic": "月5回",
  "skillCertify-tracks-recommendation-monthly-limit-pro": "月20回",
  "skillCertify-tracks-recommendation-job-role": "職務",
  "skillCertify-tracks-recommendation-job-role-placeholder": "職務を選択してください。",
  "skillCertify-tracks-recommendation-job-role-backend": "バックエンド開発者",
  "skillCertify-tracks-recommendation-job-role-frontend": "フロントエンド開発者",
  "skillCertify-tracks-recommendation-job-role-ai-ml": "AI/MLエンジニア",
  "skillCertify-tracks-recommendation-work-experience-placeholder": "職務経験を選択してください。",
  "skillCertify-tracks-recommendation-work-experience-entry": "新卒~2年",
  "skillCertify-tracks-recommendation-work-experience-mid": "3~5年",
  "skillCertify-tracks-recommendation-work-experience-senior": "6年以上",
  "skillCertify-tracks-recommendation-keywords": "職務記述書または技術キーワード",
  "skillCertify-tracks-recommendation-keywords-placeholder": "職務記述書または技術キーワードを入力してください。\n例：Python、Java、AWSなど",
  "skillCertify-tracks-recommendation-submit": "推奨を受ける",
  "skillCertify-tracks-recommendation-limit-reached": "AI推奨回数をすべて使い切りました。\n次回の更新時に再びご利用いただけます。",
  "skillCertify-tracks-recommendation-fail": "一時的なエラーのため、推奨を受けることができません。\nもう一度お試しください。",
  "skillCertify-tracks-recommendation-loading": "AIが最適なトラックを探しています。\nしばらくお待ちください。",
  "skillCertify-tracks-recommendation-no-result": "入力された条件に合う推奨トラックが見つかりませんでした。\n入力した情報を修正して、もう一度お試しください。",
  "skillCertify-tracks-recommendation-edit-info": "入力した情報を修正",
  "skillCertify-tracks-recommendation-entered-info": "入力情報",
  "skillCertify-tracks-recommendation-result": "推奨トラック",
  "skillCertify-tracks-recommendation-result-guide": "以下の推奨トラックの中から、設定するトラックを選択してください。",
  "skillCertify-tracks-recommendation-matching-basis": "マッチング根拠",
  "skillCertify-tracks-recommendation-no-desired-track": "希望するトラックがありませんか？",
  "skillCertify-tracks-recommendation-edit-info-title": "入力した情報を修正しますか？",
  "skillCertify-tracks-recommendation-edit-info-description": "現在の推奨トラックが初期化されます。",
  "skillCertify-tracks-recommendation-apply-selected": "選択したトラックを適用",
  "skillCertify-tracks-recommendation-apply-success": "推奨トラックが適用されました。",
  "skillCertify-current-question": "現在の問題",
  "skillCertify-answer-status-not-submitted": "未提出",
  "skillCertify-answer-status-submitted": "提出済み",
  "skillCertify-answer-status-resubmit-required": "再提出が必要",
  "skillCertify-submit-answer-for-grading": "採点のため、回答の提出も完了してください。",
  "skillCertify-away-with-out-title": "現在の問題の回答がまだ提出されていません\n回答を提出しますか？",
  "skillCertify-away-with-out-description-1": "移動する前に回答を提出することをお勧めします。",
  "skillCertify-away-with-out-description-2": "提出後に追加の変更がある場合は、再度提出することができます。",
  "skillCertify-away-with-out-leave": "提出せずに移動",
  "skillCertify-locale-change-with-out-submitting-description": "言語を変更する前に回答を提出することをお勧めします。",
  "skillCertify-locale-change-with-out-submitting": "提出せずに言語変更",
  "skillCertify-submit-answer-require-run-code-and-save": "回答を提出するには、まず実行および保存を完了してください。",
  "skillCertify-question-provides-api-reference": "この問題では{resourcesLink}が提供されます。",
  "skillMonitor-main-description": "組織メンバーおよび外部人材の能力をデータ化し、プロジェクトの割り当て、トレーニング、採用などの意思決定などに活用できます。",
  "skillMonitor-main-sample-title": "現在はサンプルデータをご確認いただけます。",
  "skillMonitor-main-sample-description": "評価を生成すると、実際のデータが表示されます。",
  "skillMonitor-main-sample-do-not-again": "今後は表示しない",
  "skillMonitor-main-limit-permission-title": "このページにアクセスする権限がありません",
  "skillMonitor-main-limit-permission-description": "アクセス権がないため、表示できません。",
  "skillMonitor-assessments-overview": "評価の概要",
  "skillMonitor-candidates-overview": "受験者の概要",
  "common-total": "合計",
  "skillMonitor-closed-assessment-count": "終了した評価",
  "skillMonitor-chart-last": "過去",
  "skillMonitor-chart-months": "12ヶ月",
  "skillMonitor-summary-none-closed-assessment": "まだ終了した評価はありません。",
  "skillMonitor-chart-completed-candidates-count": "完了した受験者",
  "skillMonitor-summary-none-closed-candidate": "まだ完了した受験者がいません。",
  "common-average": "平均",
  "skillMonitor-main-track-level": "レベル分布",
  "skillMonitor-chart-none-track-level": "まだ受験者のレベル分布はありません。",
  "skillMonitor-chart-track-level": "受験者のトラックレベルの分布",
  "skillCertify-candidate": "受験者",
  "skillMonitor-main-assessment-list": "評価一覧",
  "skillMonitor-main-assessment-list-more": "すべての評価を見る",
  "skillMonitor-completed-candidate": "完了した受験者",
  "skillMonitor-main-candidate-list-more": "すべての受験者を見る",
  "skillMonitor-main-assessment-list-banner": "組織で作成した評価を確認することができます。",
  "skillMonitor-candidate-list-banner": "評価を完了した受験者を確認することができます。",
  "skillMonitor-action-date": "行動発生日",
  "skillMonitor-action-screen-switch": "画面切り替え",
  "skillMonitor-action-shortcut": "許可されていないショートカット",
  "skillMonitor-action-multi-monitor": "マルチモニター接続",
  "skillMonitor-action-copy": "コピー",
  "skillMonitor-action-cut": "切り取り",
  "skillMonitor-action-paste": "ペースト",
  "skillMonitor-action-type": "行動タイプ",
  "skillMonitor-filter-by": "フィルター基準",
  "skillMonitor-track-info": "トラック情報",
  "skillMonitor-assessment-submission": "提出物",
  "skillMonitor-assessment-partially-answer": "部分正解",
  "skillMonitor-assessment-incorrect-answer": "誤答",
  "skillMonitor-assessment-incorrect": "誤答",
  "skillMonitor-assessment-answerer": "{userName}さんの回答",
  "skillMonitor-assessment-answerer-none": "提出された回答はありません。",
  "skillMonitor-analysis-title": "{userName}の指標",
  "skillMonitor-analysis-metric-name": "静的解析項目",
  "common-result": "結果",
  "skillMonitor-analysis-severity": "重大性",
  "skillMonitor-analysis-metric-tooltip-DUPLICATIONS": "コードの重複を示します。",
  "skillMonitor-analysis-metric-tooltip-CYCLOMATIC_COMPLEXITY": "コードの複雑さを測定する指標で、プログラムの論理的な経路数を計算します。条件文や繰り返し文が多いほど、複雑度が高くなります。",
  "skillMonitor-analysis-metric-tooltip-BUGS": "コードに含まれる潜在的なバグを示します。",
  "skillMonitor-analysis-metric-tooltip-CODING_STYLE": "コードが一貫したスタイルや標準に従っているかどうかを評価します。",
  "skillMonitor-analysis-code-smell": "コードスメル",
  "skillMonitor-analysis-code-smell-long-method": "メソッドが長すぎて、一つのメソッドに作業が多すぎる場合。",
  "skillMonitor-analysis-code-smell-large-class": "クラスが非常に多くのフィールドやメソッドを持ち、過剰な責任を負っている場合。",
  "skillMonitor-analysis-code-smell-primitive-obsession": "基本データ型（int、string など）を過度に使用し、ドメインモデルが明確ではない場合。",
  "skillMonitor-analysis-code-smell-long-parameter-list": "メソッドのパラメーター数が多すぎて、使用や保守が難しい場合。",
  "skillMonitor-analysis-code-smell-data-clumps": "特定のデータグループが同時に現れている場合。",
  "skillMonitor-analysis-code-smell-alternative-classes-with-different-interfaces": "同様の機能を持つクラスが同じではないインターフェースを使用している場合。",
  "skillMonitor-analysis-code-smell-refused-bequest": "サブクラスが親クラスから継承したメソッドやフィールドを使用しない場合。",
  "skillMonitor-analysis-code-smell-switch-statements": "switch文やif-elseブロックが繰り返し使用されたり、過剰に複雑な場合。",
  "skillMonitor-analysis-code-smell-temporary-field": "クラスのフィールドが特定の状況でしか使用されず、コードの可読性と保守性を損なう場合。",
  "skillMonitor-analysis-code-smell-divergent-change": "一つのクラスが異なる理由で頻繁に変更される場合。",
  "skillMonitor-analysis-code-smell-parallel-inheritance-hierarchies": "あるクラス階層が他のクラス階層と並行構造を持ち、強い依存関係がある場合。",
  "skillMonitor-analysis-code-smell-shotgun-surgery": "小さな変更がプロジェクト内の複数のクラスに広がり、修正が必要になる場合。",
  "skillMonitor-analysis-code-smell-comments": "コード自体では理解できず、過剰なコメントが必要だったり、コメントのみで意図が伝わる場合。",
  "skillMonitor-analysis-code-smell-duplicate-code": "同じコードが複数の場所で重複している場合。",
  "skillMonitor-analysis-code-smell-data-class": "フィールドと getter/setter メソッドだけを持つデータ専用クラス。",
  "skillMonitor-analysis-code-smell-dead-code": "もはや使用されていないコードがプロジェクトに残っている場合。",
  "skillMonitor-analysis-code-smell-lazy-class": "クラスが非常に少ない責任しか持たず、その存在意義が乏しい場合。",
  "skillMonitor-analysis-code-smell-speculative-generality": "将来必要になるかもしれない可能性を考慮して書かれた、現時点では不要な一般化されたコード。",
  "skillMonitor-analysis-code-smell-feature-envy": "メソッドが自分の所属するクラスよりも他のクラスのデータに強く依存している場合。",
  "skillMonitor-analysis-code-smell-inappropriate-intimacy": "二つのクラスが密接に依存し合い、お互いの内部に深くアクセスしている場合。",
  "skillMonitor-analysis-code-smell-incomplete-library-class": "使用しているライブラリクラスが必要な機能を提供しておらず、不便を引き起こす場合。",
  "skillMonitor-analysis-code-smell-message-chains": "メソッド呼び出しが連続的に接続され、過度に長いチェーン形態を持つ場合。",
  "skillMonitor-assessment-candidates-result": "受験者の結果",
  "skillMonitor-assessment-report-guide": "レポートの解釈ガイド",
  "skillMonitor-assessment-summary-title": "評価サマリー",
  "skillMonitor-track-summary-title-change": "トラックサマリー",
  "skillMonitor-skill-summary-title": "スキルサマリー",
  "skillMonitor-assessment-summary-candidates-rate": "完了率",
  "skillMonitor-assessment-summary-skill-rate": "スキル保有率",
  "skillMonitor-assessment-summary-result": "評価結果サマリー",
  "skillMonitor-assessment-summary-track-table-title": "トラック別説明",
  "skillMonitor-track-summary-result": "トラック結果サマリー",
  "skillMonitor-track-summary-score-info": "トラックのスコア情報",
  "skillMonitor-track-summary-min": "最低",
  "skillMonitor-track-summary-mid": "中間",
  "skillMonitor-track-summary-max": "最高",
  "skillMonitor-track-summary-highest": "最も高い",
  "skillMonitor-track-summary-lowest": "最も低い",
  "skillMonitor-track-summary-score-highest-info": "平均スコアが最も高いトラックです。",
  "skillMonitor-track-summary-score-lowest-info": "平均スコアが最も低いトラックです。",
  "skillMonitor-track-summary-high": "高い",
  "skillMonitor-track-summary-low": "低い",
  "skillMonitor-track-summary-table-standard-deviation": "標準偏差",
  "skillMonitor-track-summary-table-average-time-taken": "平均所要時間",
  "skillMonitor-assessment-candidates-chart-track-score": "評価受験者のトラックスコア分布",
  "skillMonitor-all-candidates-based-info-top": "上位",
  "skillMonitor-all-candidates-based-info-bottom": "下位",
  "skillMonitor-assessment-candidates-chart-track-score-range": "スコア範囲",
  "skillMonitor-assessment-candidates-chart-track-time-taken-range": "所要時間（分）範囲",
  "skillMonitor-assessment-candidates-chart-track-skill-rate-range": "スキル保有率（％）範囲",
  "skillMonitor-assessment-candidates-chart-percentage": "評価受験者の割合",
  "skillMonitor-assessment-candidates-chart-button": "範囲別受験者を見る",
  "skillMonitor-assessment-candidates-chart-track-time-taken": "評価受験者のトラック所要時間分布",
  "skillMonitor-track-summary-skill-acquisition-rate-and-time-taken-info": "トラックスキル保有率および所要時間の情報",
  "skillMonitor-track-summary-skill-rate-highest-info": "平均スキル保有率が最も高いトラックです。",
  "skillMonitor-track-summary-skill-rate-lowest-info": "平均スキル保有率が最も低いトラックです。",
  "skillMonitor-assessment-candidates-chart-track-skill-rate": "評価受験者のトラックスキル保有率分布",
  "skillMonitor-track-summary-skill-info": "トラックスキル情報",
  "skillMonitor-track-summary-skill-acquired": "獲得",
  "skillMonitor-track-summary-skill-needs-Improvement": "より学習が必要",
  "skillMonitor-track-summary-skill-not-acquired": "未獲得",
  "skillMonitor-assessment-candidates-chart-track-skill-level": "評価受験者のトラックスキルレベル分布",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend": "スキルレベル",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-acquired": "コンピテンシーを持っている",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-needs-Improvement": "概念は理解しているが、実務での適用と活用におけるコンピテンシーの改善が必要",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-not-acquired": "コンピテンシーを持っていない",
  "skillMonitor-assessment-summary-result-none-data": "まだ結果サマリーはありません。評価終了後に結果サマリーが生成されます。",
  "skillMonitor-candidate-report-unsubmitted-1": "受験者は、評価項目全般にわたって解答を提出しませんでした。\nこれにより、各スキルの習得状況および詳細なレベルを客観的に判断するための根拠が確保されず、総合的なレベル診断を行うことができません。",
  "skillMonitor-candidate-report-unsubmitted-2": "本評価において、受験者が提出した解答がなかったため、該当スキルを評価することができません。",
  "skillMonitor-sort-by": "並び替え基準",
  "skillMonitor-candidates-summary-title": "受験者サマリー",
  "skillMonitor-candidates-summary-result": "受験者結果サマリー",
  "skillMonitor-score-based-info": "スコア基準",
  "skillMonitor-skill-acquisition-rate-based-info": "スキル保有率基準",
  "skillMonitor-candidates-Integrity-concerns-info": "インテグリティ懸念のある受験者 ",
  "skillMonitor-candidates-Integrity-reason": "理由",
  "skillMonitor-candidate-action-analysis-result": "行動分析結果",
  "skillMonitor-candidate-report": "受験者レポート",
  "skillMonitor-assessment-summary-score-info": "評価のスコア情報",
  "skillMonitor-summary-table-assessment-average-score": "評価受験者の平均スコアとの比較",
  "skillMonitor-summary-table-assessment-average-none": "総受験者が1名のため、\n平均との比較データは提供されません。",
  "skillMonitor-assessment-candidates-chart-assessment-score": "評価受験者の評価スコア分布",
  "skillMonitor-assessment-candidates-chart-assessment-time-taken": "評価受験者の評価所要時間分布",
  "skillMonitor-assessment-summary-skill-acquisition-rate-and-time-taken-info": "評価スキル保有率および所要時間の情報",
  "skillMonitor-summary-table-assessment-average-skill-rate": "評価受験者の平均スキル保有率との比較",
  "skillMonitor-assessment-candidates-chart-assessment-skill-rate": "評価受験者の評価スキル保有率分布",
  "skillMonitor-assessment-submission-button": "提出物を見る",
  "skillMonitor-track-summary-score-highest-info-2": "スコアの配点が最も高いトラックです。",
  "skillMonitor-track-summary-score-lowest-info-2": "スコアの配点が最も低いトラックです。",
  "skillMonitor-track-summary-skill-rate-highest-info-2": "スキル保有率が最も高いトラックです。",
  "skillMonitor-track-summary-skill-rate-lowest-info-2": "スキル保有率が最も低いトラックです。",
  "skillMonitor-candidate-strength-button": "強みを見る",
  "skillMonitor-candidate-areas-for-improvement-button": "改善点を見る",
  "skillMonitor-candidate-strength-areas-for-improvement-button": "強みと改善点を見る",
  "skillMonitor-candidate-strength": "強み",
  "skillMonitor-candidate-areas-for-improvement": "改善点",
  "skillMonitor-candidate-sw-quality-analysis-result": "SW品質分析結果",
  "skillMonitor-candidate-sw-quality-analysis-result-info": "SW品質分析結果は、分析可能な問題に対してのみ提供されます。",
  "skillMonitor-candidate-sw-quality-analysis-result-count": "{total}個の問題中{question}個の問題",
  "skillMonitor-candidate-sw-quality-analysis-summary-result": "SW品質分析結果サマリー",
  "skillMonitor-candidate-sw-quality-analysis-recommendations-for-improvement": "改善推奨事項",
  "skillMonitor-static-analysis-metrics-count": "{count}個の指標",
  "skillMonitor-analysis-primary-file": "解析対象ファイル",
  "skillMonitor-analysis-pass": "合格",
  "skillMonitor-analysis-warning": "警告",
  "skillMonitor-analysis-fail": "失敗",
  "skillMonitor-analysis-not-applicable": "計算されていない",
  "skillMonitor-candidate-action-analysis-info": "行動分析情報",
  "skillMonitor-candidates-Integrity-grade": "インテグリティ等級",
  "skillMonitor-candidates-grade": "レベル",
  "skillMonitor-candidates-Integrity-grade-1": "不正行為なし",
  "skillMonitor-candidates-Integrity-grade-1-description": "評価中に疑わしい行動や不正行為の記録は検出されず、受験者はすべての規則を遵守しました。",
  "skillMonitor-candidates-Integrity-grade-2": "わずかな疑い行動",
  "skillMonitor-candidates-Integrity-grade-2-description": "評価中にいくつかの疑わしい行動が検出されたが、明確な不正行為の証拠は見つからず、受験者は全般的に規則を遵守しました。",
  "skillMonitor-candidates-Integrity-grade-3": "疑わしい行動",
  "skillMonitor-candidates-Integrity-grade-3-description": "評価中に不正行為の可能性が高い行動が検出され、追加確認が必要です。",
  "skillMonitor-candidates-Integrity-grade-4": "明らかに不正行為があった",
  "skillMonitor-candidates-Integrity-grade-4-description": "確な不正行為の行動が確認されましたが、成功したかは不明です。",
  "skillMonitor-candidates-Integrity-grade-5": "不正行為確認",
  "skillMonitor-candidates-Integrity-grade-5-description": "評価中に明確な不正行為が発生し、テスト結果の信頼性が大きく損なわれました。",
  "skillMonitor-report-candidate-action-analysis-clean-default-reason": "本評価において不正行為は確認されませんでした。",
  "skillMonitor-candidate-action": "受験者行動履歴",
  "skillMonitor-candidate-action-count": "件",
  "skillMonitor-candidate-video-delete": "動画が削除されました。",
  "skillMonitor-candidate-video-no-save": "動画が保存されませんでした。",
  "skillMonitor-candidate-recommended-for-review-label": "結果に疑いがあります",
  "skillMonitor-candidate-video-recording-duration-information": "録画時間情報",
  "skillMonitor-candidate-video-start": "開始",
  "skillMonitor-candidate-video-end": "終了",
  "skillMonitor-candidate-video-current": "現在",
  "skillMonitor-candidate-video-no-face-voice-recording": "顔/音声の録画なし",
  "skillMonitor-candidate-video-no-screen-recording": "画面録画なし",
  "skillMonitor-candidate-video-no-description": "録画の空白は、受験者の離脱やシステム上の問題などにより、録画データが存在しない区間です。",
  "skillMonitor-candidate-video-playback-speed": "再生速度",
  "skillMonitor-candidate-video-view-full-screen": "全画面表示",
  "skillMonitor-candidate-video-screen-recording": "画面録画",
  "skillMonitor-assessment-report-get-by-email": "評価レポートをメールアドレスで受け取る",
  "skillMonitor-candidate-report-get-by-email": "受験者レポートをメールアドレスで受け取る",
  "skillMonitor-all-candidate-report-get-by-email": "すべての受験者レポートをメールアドレスで受け取る",
  "skillMonitor-assessment-send-report-title": "レポートを受け取るメールアドレスを入力してください",
  "skillMonitor-assessment-send-report-description": "レポートは{pdf}で、入力されたメールアドレスに送信され、送信に時間がかかる場合があります。",
  "skillMonitor-assessment-send-report-description-pdf": "PDF形式",
  "skillMonitor-assessment-send-report-description-zip": "ZIP形式",
  "skillMonitor-assessment-send-report-button": "レポートを送信",
  "skillMonitor-assessment-send-report-success": "レポートの送信リクエストが完了しました。",
  "skillMonitor-assessment-send-report-fail": "レポートの送信リクエストを完了できませんでした。\nもう一度お試しください。",
  "home-event-title": "コードプレッソイベント",
  "home-event-count": "個のイベント",
  "home-event-type-Webinar": "ウェビナー",
  "home-event-type-Conference": "カンファレンス",
  "home-event-type-Seminar": "セミナー",
  "home-event-type-Workshop": "ワークショップ",
  "home-event-type-NetworkingEvent": "ネットワーキングイベント",
  "home-event-type-Exhibition": "展示会",
  "home-event-type-LaunchEvent": "ローンチイベント",
  "home-event-type-Learnathon": "短期集中型学習",
  "home-event-engage-Online": "オンライン",
  "home-event-engage-Offline": "オフライン",
  "home-event-engage-OnOffline": "オン/オフライン",
  "home-event-none": "まだ登録されたイベントはありません。",
  "home-event-all": "すべてのイベント",
  "home-event-info": "イベント情報",
  "home-event-info-date": "イベント日時",
  "home-event-info-period": "登録期間",
  "home-event-info-location": "場所",
  "home-event-info-language": "言語",
  "common-share": "共有",
  "home-event-register": "登録",
  "home-event-speakers": "プレゼンター",
  "home-blog-title": "コードプレッソブログ",
  "home-blog-count": "個のブログ投稿",
  "home-blog-none": "まだ登録されたブログ投稿はありません。",
  "home-blog-all-post": "すべてのブログ投稿",
  "home-blog-author": "著者",
  "home-blog-about-codepresso": "コードプレッソについて",
  "home-blog-about-codepresso-description": "コードプレッソは、企業が開発者のスキルを可視化し、スキルベースのデジタルタレントマネジメントを強化するためのHR SaaSサービスを提供しています。企業はデジタルワークフォースを簡単に評価、診断、採用し、個別のアップスキリング/リスキリングコンテンツを提供できます。このプロセス全体で収集されたすべてのデータにより、組織はデータに基づいた意思決定ができます。",
  "home-blog-about-codepresso-learn-more": "コードプレッソについて詳しく知る",
  "home-news-title": "コードプレッソニュース",
  "home-news-count": "件のニュース",
  "home-news-none": "まだニュースはありません。",
  "home-news-topic": "ニュース",
  "dashboard-my-profile": "プロフィールを見る",
  "account-profile": "プロフィール",
  "profile-private-info": "この情報は非公開です。",
  "profile-skill-none-data": "まだ作成されたスキルはありません。",
  "profile-bios-none-data": "まだ作成された自己紹介はありません。",
  "profile-activity-history-none-data": "まだ活動履歴がありません。",
  "profile-work-experience-none-data": "まだ作成された職務経験はありません。",
  "profile-education-none-data": "まだ作成された学歴はありません。",
  "profile-edit": "編集",
  "profile-image-upload-fail": "画像をアップロードできません。\nファイルがJPG、JPEG、PNG、またはBMPであることを確認してください。",
  "profile-change-success": "プロファイルの変更が保存されました。",
  "profile-change-fail": "プロファイルの変更を保存できませんでした。\nもう一度お試しください。",
  "profile-private": "非公開",
  "profile-public": "公開",
  "profile-private-change-success": "プロフィール情報が非公開になりました。",
  "profile-public-change-success": "プロフィール情報が公開されました。",
  "profile-job-offer": "採用提案",
  "profile-job-offer-info": "この設定を有効にすると、採用提案を受け取ることができます。",
  "profile-add": "追加",
  "profile-headline": "ヘッドライン",
  "profile-headline-placeholder": "ヘッドラインを入力してください。",
  "profile-headline-error": "ヘッドラインは200文字以内で入力してください。",
  "profile-personal-info-title": "個人情報",
  "profile-gender": "性別",
  "profile-gender-drop-item-default": "性別を選択してください。",
  "profile-gender-drop-item-male": "男性",
  "profile-gender-drop-item-female": "女性",
  "profile-gender-drop-item-other": "その他",
  "profile-gender-drop-item-not-say": "選択しない",
  "profile-phone-number": "携帯電話番号",
  "profile-phone-number-placeholder": "携帯電話番号を入力してください。",
  "profile-phone-number-error": "携帯電話番号は25文字以内で入力してください。",
  "profile-links": "リンク",
  "profile-links-error-linkedIn": "LinkedInのURLをご入力ください。",
  "profile-links-error-gitHub": "GitHubのURLをご入力ください。",
  "profile-links-add": "リンクを追加",
  "profile-links-remove": "このリンクを削除しますか？",
  "profile-links-remove-success": "リンクが正常に削除されました。",
  "profile-skills": "スキル",
  "profile-skills-search-placeholder": "スキルを検索",
  "profile-skills-search-none": "{skill}が見つかりませんか？このスキルを追加しますか？",
  "profile-skills-remove": "このスキルを削除しますか？",
  "profile-skills-remove-success": "スキルが正常に削除されました。",
  "profile-about-me": "自己紹介",
  "profile-title": "タイトル",
  "profile-title-placeholder": "タイトルを入力してください。",
  "profile-title-error": "タイトルは50文字以内で入力してください。",
  "profile-content": "内容",
  "profile-content-placeholder": "内容を入力してください。",
  "profile-content-error": "内容は1500文字以内で入力してください。",
  "profile-about-me-delete": "この自己紹介を削除しますか？",
  "profile-about-me-delete-success": "自己紹介が正常に削除されました。",
  "profile-about-me-delete-fail": "自己紹介を削除できませんでした。\nもう一度お試しください。",
  "profile-activity-history": "活動履歴",
  "profile-view-more": "もっと見る",
  "profile-view-less": "簡単に見る",
  "profile-work-experience": "職務経験",
  "profile-work-experience-company-name": "会社名",
  "profile-work-experience-company-name-placeholder": "会社名を入力してください。",
  "profile-work-experience-company-name-error": "会社名は50文字以内で入力してください。",
  "profile-work-experience-job-title": "役職",
  "profile-work-experience-job-title-placeholder": "役職を入力してください。",
  "profile-work-experience-job-title-error": "役職は50文字以内で入力してください。",
  "profile-work-experience-location": "勤務地",
  "profile-work-experience-location-placeholder": "勤務地を入力してください。",
  "profile-work-experience-location-error": "勤務地は150文字以内で入力してください。",
  "profile-work-experience-period": "在籍中",
  "common-start-date": "開始日",
  "common-month": "月",
  "common-year": "年",
  "common-end-date": "終了日",
  "profile-period-error": "終了日は開始日より早くすることはできません。",
  "profile-work-experience-description-placeholder": "説明を入力してください。",
  "profile-work-experience-description-error": "説明は1500文字以内で入力してください。",
  "profile-work-experience-entry-delete-title": "この職務経験を削除しますか？",
  "profile-work-experience-entry-delete-success": "職務経験が正常に削除されました。",
  "profile-work-experience-entry-delete-fail": "職務経験を削除できませんでした。\nもう一度お試しください。",
  "profile-present": "現在",
  "profile-education": "学歴",
  "profile-education-school-name": "学校名",
  "profile-education-school-name-placeholder": "学校名を入力してください。",
  "profile-education-school-name-error": "学校名は50文字以内で入力してください。",
  "profile-education-degree": "学位",
  "profile-education-degree-placeholder": "学位を入力してください。",
  "profile-education-degree-error": "学位は50文字以内で入力してください。",
  "profile-education-major": "専攻",
  "profile-education-major-placeholder": "専攻を入力してください。",
  "profile-education-major-error": "専攻は50文字以内で入力してください。",
  "profile-education-current-studying": "在学中",
  "profile-education-delete-title": "この学歴を削除しますか？",
  "profile-education-delete-success": "学歴が正常に削除されました。",
  "profile-education-delete-fail": "学歴を削除できませんでした。\nもう一度お試しください。",
  "profile-access-limit": "このプロフィールにはアクセスできません",
  "profile-access-limit-description": "退会したメンバーのプロフィールは表示できません。",
  "advance-practice-assessment": "練習評価",
  "learning-assessment-goal": "練習評価の目的",
  "learning-assessment-goal-description": "このトラックレベルに対する経験がどれほどあるかを知りたいです。",
  "learning-assessment-evaluate": "問題構成",
  "learning-assessment-evaluate-description": "練習評価は実習と選択問題から構成されています。",
  "learning-assessment-how-to-complete": "完了するには",
  "learning-assessment-how-to-complete-description": "練習評価に合格するには、合格点に達する必要があります。",
  "common-retake": "再受験",
  "learning-progress": "進行状況",
  "learning-leave-warning-title": "評価画面から退出しますか？",
  "learning-leave-warning-description": "提出された回答が保存されない場合があります。",
  "learning-leave": "退出",
  "learning-finished-question": "回答が提出されました。",
  "learning-assessment-date": "評価日",
  "learning-completed-banner": "評価を完了しました",
  "learning-completed-success-description": "評価に合格しました。\n新しいレベルの練習評価を開始するか、完了したレベルの練習評価の結果を確認できます。",
  "learning-completed-fail-description": "合格点に達しませんでした。\n再受験して評価を完了してください。",
  "skillCertify-view-result": "結果を見る",
  "pricing-menu": "料金",
  "pricing-title": "技術スキル評価のためのプラン",
  "pricing-content": "目的に合ったプランをお選びください",
  "pricing-monthly": "月額",
  "pricing-annual": "年額",
  "pricing-off": "{percent}%割引",
  "pricing-basic": "ベーシック",
  "pricing-pro": "プロ",
  "pricing-enterprise": "エンタープライズ",
  "pricing-recommend": "おすすめ",
  "pricing-year": "年",
  "pricing-custom-pricing": "カスタム料金",
  "pricing-basic-report": "基本レポート",
  "pricing-basic-skill-report": "基本スキルレポート",
  "pricing-report-language-single": "言語1つ",
  "pricing-ai-assessment-recommendation-times": "AIカスタム評価推奨月{count}回",
  "pricing-report-language-unlimited": "言語制限なし",
  "pricing-administrator-account-plural": "組織管理者無制限",
  "pricing-advanced-report": "高度なレポート",
  "pricing-advanced-skill-report": "高度なスキルレポート",
  "pricing-all-skill-assessments": "すべてのスキル評価",
  "pricing-custom-questions": "評価問題のカスタム設計",
  "pricing-account-manager": "専任マネージャー",
  "pricing-ai-assessment-recommendation-unlimited": "AIカスタム評価推奨無制限",
  "pricing-get-started": "開始する",
  "pricing-coming-soon": "近日公開",
  "pricing-current-plan": "現在のプラン",
  "pricing-upgrade": "アップグレード",
  "pricing-downgrade": "ダウングレード",
  "pricing-compare-features-by-plan": "プラン別機能比較",
  "pricing-feature": "機能",
  "pricing-monthly-basic-assessment-invitation-credits": "月次基本評価招待クレジット（繰り越し不可）",
  "pricing-contract-terms": "契約条件",
  "pricing-purchase-additional-credits": "評価招待クレジットを追加購入",
  "pricing-per-credit": "クレジットあたり{price}",
  "pricing-assessment-features": "評価機能",
  "pricing-create-basic-assessment": "基本評価を作成",
  "pricing-advanced-assessment": "プロジェクトスキル評価",
  "pricing-core-assessment": "実務スキル評価",
  "pricing-ai-agent-assessment": "AI活用スキル評価",
  "pricing-core-assessment-description": "Coreは、デジタルIT分野の核心的な技術力を測定する実務中心の評価で、現業のシナリオを反映した問題と実習ベースの評価を通じて、個人の技術理解度と実務活用力を診断するために活用できます。",
  "pricing-advanced-assessment-description": "E2Eは、実務環境で、実際の業務に近いプロジェクト課題を実行し、設計から実装までの開発者の実務能力を総合的に検証するために活用できます。",
  "pricing-ai-agent-assessment-description": "AI Fluentは、実務プロジェクトを基に、AI活用力から個人のAIガバナンス能力までを総合的に検証し、組織のAIベース開発文化の点検と能力強化の方向性の導出に活用できます。",
  "pricing-core-assessment-filter-description": "Coreは、",
  "pricing-core-assessment-filter-description-1": "デジタルIT分野の核心的な技術力を測定する実務中心の評価で、現業のシナリオを反映した問題と実習ベースの評価を通じて、個人の技術理解度と実務活用力を診断するために活用できます。",
  "pricing-advanced-assessment-filter-description": "E2Eは、",
  "pricing-advanced-assessment-filter-description-1": "実務環境で、実際の業務に近いプロジェクト課題を実行し、設計から実装までの開発者の実務能力を総合的に検証するために活用できます。",
  "pricing-ai-agent-assessment-filter-description": "AI Fluentは、",
  "pricing-ai-agent-assessment-filter-description-2": "実務プロジェクトを基に、AI活用力から個人のAIガバナンス能力までを総合的に検証し、組織のAIベース開発文化の点検と能力強化の方向性の導出に活用できます。",
  "pricing-report-language": "スキルレポート言語",
  "pricing-report-language-count-1": "1つ",
  "pricing-report-language-count-2": "制限なし",
  "pricing-certificate-provided": "スキル証書",
  "pricing-ai-features": "AI機能",
  "pricing-report": "スキルレポート",
  "pricing-ai-assessment-recommendation": "AIカスタム評価推奨",
  "pricing-times-a-month": "月{count}回",
  "pricing-management-and-support": "管理とサポート",
  "pricing-person": "1人",
  "pricing-administrator": "組織管理者",
  "pricing-ats-integration": "採用管理システム(ATS)",
  "pricing-to-be-added": "追加予定",
  "pricing-basic-ats-provided": "基本ATS提供",
  "pricing-custom-integration": "専用ATS構築",
  "pricing-support": "サポート",
  "pricing-faq": "よくある質問",
  "pricing-faq-question-1": "どのプランを選択すればよいですか?",
  "pricing-faq-question-1-answer-1": "評価の運用目的と必要な機能レベルに応じて、プランを選択できます。",
  "pricing-faq-question-1-answer-2": "プラン",
  "pricing-faq-question-1-answer-3": "おすすめ対象",
  "pricing-faq-question-1-answer-4": "基本監督と基本スキルレポートで技術スキル評価を開始したい組織",
  "pricing-faq-question-1-answer-5": "強化監督やプロジェクトスキル評価など、高度化された評価機能を必要とする組織",
  "pricing-faq-question-1-answer-6": "すべてのスキル評価、専用ATS構築、専任マネージャーによるサポートが必要な組織",
  "pricing-faq-question-2": "評価招待クレジットとは何ですか?",
  "pricing-faq-question-2-answer-1": "評価招待クレジットは、受験者を評価に招待する際に使用される単位です。",
  "pricing-faq-question-2-answer-2": "評価を実施・運用するには、受験者数と評価の設定内容に応じて評価招待クレジットが必要です。",
  "pricing-faq-question-3": "受験者1名を招待する際、いくつのクレジットが使用されますか?",
  "pricing-faq-question-3-answer-1": "基本評価の場合、受験者1名あたり評価招待クレジット1つが使用されます。",
  "pricing-faq-question-3-answer-2": "ただし、プロジェクトスキル評価などの高度化された評価機能を含める場合、評価の設定内容に応じて追加のクレジットが使用される場合があります。",
  "pricing-faq-question-4": "評価招待クレジットはいつ使用されますか?",
  "pricing-faq-question-4-answer-1": "受験者を招待する際、招待する受験者数と評価の設定内容に応じて評価招待クレジットが使用されます。",
  "pricing-faq-question-4-answer-2": "受験者が評価を開始する前に受験者リストから削除された場合、その受験者に対する評価招待クレジットの使用がキャンセルされます。",
  "pricing-faq-question-4-answer-3": "ただし、受験者が評価を開始した後は、評価招待クレジットの使用をキャンセルできません。",
  "pricing-faq-question-5": "月ごとの基本評価招待クレジットをすべて使い切るとどうなりますか?",
  "pricing-faq-question-5-answer-1": "月ごとの基本評価招待クレジットをすべて使い切った場合、クレジットをチャージしてご利用いただけます。",
  "pricing-faq-question-5-answer-2": "クレジットのチャージは組織最高管理者のみが可能です。",
  "pricing-faq-question-5-answer-3": "チャージクレジットには別途の有効期限はありませんが、サブスクリプション期間中のみチャージおよび使用できます。",
  "pricing-faq-question-5-answer-4": "ただし、エンタープライズプランは別途契約条件に基づいて運用されるため、クレジットのチャージが必要な場合は別途お問い合わせが必要です。",
  "pricing-faq-question-6": "カードの有効期限などで決済に失敗した場合はどうなりますか?",
  "pricing-faq-question-6-answer-1": "決済に失敗した場合、組織最高管理者のメールアドレスに案内メールが送信されます。",
  "pricing-faq-question-6-answer-2": "決済に失敗した場合、自動的に最大3回まで再試行されることがあります。",
  "pricing-faq-question-6-answer-3": "その後も決済に失敗する場合、自動決済の再試行が停止され、サブスクリプションは終了します。",
  "pricing-faq-question-7": "サブスクリプションを解約するとどうなりますか?",
  "pricing-faq-question-7-answer-1": "サブスクリプションを解約すると、次回の請求日から自動決済が停止されます。",
  "pricing-faq-question-7-answer-2": "すでに決済済みのサブスクリプション期間が残っている場合、その期間中は既存のプランを引き続きご利用いただけます。",
  "pricing-faq-question-7-answer-3": "サブスクリプション期間が終了すると、保有しているチャージクレジットも使用できなくなり、サブスクリプションを再開すると再度使用できます。",
  "pricing-faq-question-8": "払い戻しは可能ですか?",
  "pricing-faq-question-8-answer-1": "原則として、サブスクリプションプランおよびチャージクレジットのお支払い金額は払い戻しできません。",
  "pricing-faq-question-8-answer-2": "ただし、当社の責めに帰すべき事由または関連法令上、払い戻しが必要な例外的な状況では、払い戻しを検討する場合があります。",
  "pricing-faq-question-8-answer-3": "詳細については、{link}をご覧ください。",
  "pricing-faq-question-9": "払い戻し金額はどのような基準で算出され、払い戻しはどのように申請できますか?",
  "pricing-faq-question-9-answer-1": "例外的に払い戻しが承認される場合、払い戻し金額は実際のお支払い金額（税込）に基づいて算出されます。",
  "pricing-faq-question-9-answer-2": "クーポンやプロモーションによる割引額は、払い戻し金額に含まれません。",
  "pricing-faq-question-9-answer-3": "払い戻しに関するお問い合わせは、画面下部のお問い合わせアイコン(チャネルトーク)または{link1}までご連絡ください。\n検討後、払い戻しの可否と最終的な払い戻し金額をご案内いたします。",
  "pricing-info-1-title": "サブスクリプションプランは、組織アカウントのみご利用いただけます",
  "pricing-info-2-title": "サブスクリプションプランをご利用いただくには、まず組織を作成する必要があります",
  "pricing-info-2-description": "組織設定へ移動",
  "pricing-info-3-title": "サブスクリプションプランの決済は、組織最高管理者のみが行えます",
  "payment-payment-information": "決済情報",
  "payment-organization-information": "組織情報",
  "payment-payment-method": "支払い方法",
  "payment-cardholder-name": "カード名義",
  "payment-card-number": "カード番号",
  "payment-expiration-date": "有効期限",
  "payment-security-code": "セキュリティコード",
  "payment-product-price": "商品金額",
  "payment-coupon-discount": "クーポン割引",
  "payment-select-coupon": "クーポンを選択",
  "payment-coupon-discount-amount": "クーポン割引金額",
  "payment-cancel-coupon": "クーポンをキャンセル",
  "payment-estimated-payment-amount": "お支払い予定金額",
  "payment-tax-description": "税金は決済時に計算されます。",
  "payment-agree-all-check": "すべてに同意します。",
  "payment-agree-required": "必須",
  "payment-agree-check-1": "{policy}及び{term}に同意します。",
  "payment-agree-check-2": "サブスクリプションの自動更新および支払い方法の保存・請求に同意します。",
  "payment-subscribe": "購読する",
  "payment-subscribe-processing": "処理中です",
  "payment-subscribe-info-1": "請求周期に基づき自動的に請求されます。",
  "payment-subscribe-info-2": "決済日がその月に存在しない日付(例：31日)にあたる場合、決済はその月の末日に行われます。",
  "payment-cardholder-name-error-1": "カード名義を入力してください。",
  "payment-cardholder-name-error-2": "カード名義は1～20文字で入力してください。",
  "payment-card-number-error-1": "カード番号を入力してください。",
  "payment-card-number-error-2": "カード番号を再度ご確認ください。",
  "payment-expiration-date-error-1": "有効期限を入力してください。",
  "payment-expiration-date-error-2": "有効期限を再度ご確認ください。",
  "payment-security-code-error-1": "セキュリティコードを入力してください。",
  "payment-security-code-error-2": "セキュリティコードを再度ご確認ください。",
  "payment-coupon": "クーポン",
  "payment-my-coupons": "マイクーポン",
  "payment-annual-billing-only": "年額決済のみ",
  "payment-monthly-subscription-only": "月額決済のみ",
  "payment-first-purchase-only": "初回決済のみ",
  "payment-benefits": "特典",
  "payment-validity-period": "有効期限",
  "payment-days-left": "あと00日",
  "payment-coupon-applied-success": "クーポンが適用されました。",
  "payment-coupon-applied-fail": "クーポンを適用できませんでした。\nもう一度お試しください。",
  "payment-register-coupon": "クーポン登録",
  "payment-coupon-code": "クーポンコード",
  "payment-coupon-code-placeholder": "クーポンコードを入力してください。",
  "payment-coupon-code-error": "無効なクーポンコードです。",
  "payment-coupon-code-success": "クーポンが登録されました。",
  "payment-coupon-code-fail": "クーポンを登録できませんでした。\nもう一度お試しください。",
  "payment-agree-required-error": "必須項目に同意してください。",
  "payment-error-title": "決済に失敗しました",
  "payment-error-contents": "入力されたカード情報を確認し、もう一度お試しください。\n決済が引き続き失敗する場合は、別のカードを使用するか、カード会社にお問い合わせください。\n問題が解決しない場合は、{contact}メニューからご連絡ください。",
  "payment-error-contents-2": "もう一度お試しください。\n決済が引き続き失敗する場合は、別のカードを使用するか、カード会社にお問い合わせください。\n問題が解決しない場合は、{contact}メニューからご連絡ください。",
  "payment-payment-method-none": "まだ登録された支払い方法がありません。",
  "payment-payment-method-register": "支払い方法を登録する",
  "payment-payment-method-register-success": "支払い方法の登録が完了しました。",
  "payment-payment-method-register-fail-title": "支払い方法の登録に失敗しました",
  "payment-payment-method-register-fail-contents": "カード情報を確認し、もう一度お試しください。\n決済が引き続き失敗する場合は、別のカードを使用するか、カード会社にお問い合わせください。\n問題が解決しない場合は、{contact}メニューからご連絡ください。",
  "payment-payment-method-change-fail-title": "支払い方法の変更に失敗しました",
  "payment-complete-title": "決済完了",
  "payment-complete-payment-history": "支払い履歴",
  "payment-complete-payment-date": "決済日",
  "payment-complete-payment-amount": "決済金額",
  "payment-complete-view-invoice": "請求書を見る",
  "payment-complete-next-billing-date": "次回決済日",
  "payment-complete-description": "詳細については、{payment}をご確認ください。",
  "payment-complete-button": "サブスクリプション管理へ移動",
  "learning-away-with-out-title": "回答を提出せずに移動しますか？",
  "learning-away-with-out-description": "次に移動する前に回答を提出して保存するのをお勧めします。\n提出後に追加の変更がある場合は、再度提出することができます。",
  "learning-away-with-out-leave": "提出せずに移動",
  "learning-away-with-out-stay": "滞在する",
  "skillCertify-locale-change-away-with-out-title": "回答を保存せずに言語を変更しますか？",
  "skillCertify-locale-change-away-with-out-description": "言語を変更する前に回答を提出して保存するのをお勧めします。\n提出後に追加の変更がある場合は、再度提出することができます。",
  "skillCertify-locale-change-away-with-out": "保存せずに言語変更",
  "terms-agree-title": "",
  "terms-agree-check-1": "",
  "terms-agree-check-2": "",
  "terms-agree-check-3": "",
  "skillCertify-not-participated": "",
  "skillCertify-no-show": "",
  "skillCertify-candidate-no-show-date": "",
  "skillCertify-proctoring-program-currently-running-title": "",
  "skillCertify-proctoring-program-currently-running-description": "",
  "skillCertify-close-proctoring-program-title": "",
  "skillCertify-close-proctoring-program-description": "",
  "skillCertify-close-proctoring-program-button": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-no-use": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-check-required": "",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone-check-required": "",
  "skillCertify-assessment-completed-close-proctoring-program": "",
  "skillMonitor-track-summary-table-all-average-score": "",
  "skillMonitor-all-candidates-based-info": "",
  "skillMonitor-all-candidates-based-info-median": "",
  "skillMonitor-track-summary-table-all-average-skill-rate": "",
  "skillMonitor-candidate-sw-quality-analysis-info": "",
  "skillMonitor-candidate-code-quality-summary-result": "",
  "skillMonitor-candidate-code-quality-grade": "",
  "skillMonitor-candidate-code-quality-details": "",
  "skillMonitor-candidate-code-button": "",
  "skillMonitor-static-analysis-metrics": "",
  "skillMonitor-static-analysis": "",
  "skillMonitor-analysis-severity-medium": "",
  "skillMonitor-candidate-architecture-quality-summary-result": "",
  "skillMonitor-candidate-architecture-quality-grade": "",
  "skillMonitor-candidate-architecture-quality-details": "",
  "user-grades-type-chief-admin": "",
  "skillCertify-device-block-title": "評価はPC環境でのみ受けられます",
  "skillCertify-device-block-description": "PCから接続して、もう一度お試しください。\nサポートが必要な場合は、チャネルトークからお問い合わせください。",
  "skillCertify-environment-check-start-button": "受験環境の点検を開始",
  "skillCertify-environment-check-title": "受験環境を点検してください",
  "skillCertify-environment-check-description": "評価開始前に、カメラ、マイク、画面録画機能が正常に動作するか確認する必要があります。\n評価時間は、点検を完了して評価を開始した後からカウントされます。",
  "skillCertify-environment-check-result-title": "点検結果",
  "skillCertify-environment-check-status-checking": "確認中...",
  "skillCertify-environment-check-status-ok": "正常",
  "skillCertify-environment-check-status-failed": "確認が必要",
  "skillCertify-environment-check-has-failed-item": "正常に確認できなかった項目があります。",
  "skillCertify-environment-check-help-button": "解決方法を見る",
  "skillCertify-environment-check-help-title": "解決方法",
  "skillCertify-environment-check-help-camera-microphone": "カメラ/マイク",
  "skillCertify-environment-check-help-detail-guide": "詳しい解決方法はヘルプをご確認ください",
  "skillCertify-environment-check-contact-channel-talk": "サポートが必要な場合は、チャネルトークからお問い合わせください。",
  "skillCertify-environment-check-screen-share-guide-title": "画面共有機能を点検してください",
  "skillCertify-environment-check-screen-share-guide-description": "評価開始前に、画面共有機能が正常に動作するか確認する必要があります。\n点検時は**画面全体**を共有してください。\n評価時間は、点検を完了して評価を開始した後からカウントされます。",
  "skillCertify-environment-check-screen-share-button": "画面共有機能を点検する",
  "skillCertify-environment-check-screen-share-complete-title": "画面共有機能の点検が完了しました",
  "skillCertify-environment-check-screen-share-complete-description": "評価を開始するには、下のボタンをクリックしてください。",
  "skillCertify-environment-check-full-screen-error": "画面共有機能を点検するには、**画面全体**を共有する必要があります。",
  "skillCertify-environment-check-cancelled-toast": "点検を完了しないと、評価を開始できません。",
  "skillCertify-environment-check-screen-share-permission-required": "画面共有の権限が必要です\n以下の内容をご確認ください",
  "skillCertify-environment-check-item-screen-recording": "画面録画",
  "skillCertify-environment-check-resolve-issue": "受験環境の問題を解決してください",
  "skillCertify-environment-check-help-camera": "カメラの権限または接続状態を確認してください。",
  "skillCertify-environment-check-help-microphone": "マイクの権限または接続状態を確認してください。",
  "skillCertify-environment-check-help-link-button": "ヘルプを見る"
};